/**
 * Vista: Detalle/Edición de Orden de Trabajo
 * Formato: AMX-PR-FR-01
 */

import produccionService from '../services/produccion.service.js';
import tractorService from '../services/tractor.service.js';
import personaService from '../services/persona.service.js';
import recepcionService from '../services/recepcion.service.js';
import api from '../services/api.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';
import PrintOrdenTrabajo from './PrintOrdenTrabajo.js';
import { compressImage } from '../utils/imageCompressor.js';

export default {
  data: {
    orden: null,
    tractor: null,
    plantilla: null,
    clientes: [],
    distribuidores: [],
    tecnicosServicio: [],      // Técnicos de servicio (producción)
    responsablesPosventa: [],  // Responsables de área de posventa
    isNew: false,
    isReadOnly: false
  },

  async render(params) {
    // Es nuevo si no hay id o si el id es 'nueva'
    this.data.isNew = !params.id || params.id === 'nueva';

    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">${this.data.isNew ? 'Nueva Orden de Trabajo' : 'Orden de Trabajo'}</h2>
          <div id="cardHeaderActions" style="display: flex; gap: 0.5rem;">
            <button class="btn btn-secondary" onclick="router.navigate('/produccion/ordenes-trabajo')">
              Volver a Lista
            </button>
          </div>
        </div>

        <div id="ordenContent">
          <div style="text-align: center; padding: 2rem;">
            Cargando...
          </div>
        </div>
      </div>
    `;
  },

  async afterRender(params) {
    window.ordenTrabajoDetalleView = this;
    this._injectStyles();

    if (this.data.isNew) {
      await Promise.all([
        this.cargarDistribuidores(),
        this.cargarClientes(),
        this.cargarResponsablesCompletar()
      ]);
      this.renderFormularioNuevo();
    } else {
      await Promise.all([
        this.cargarOrden(params.id),
        this.cargarResponsablesCompletar()
      ]);
    }
  },

  _injectStyles() {
    if (document.getElementById('ot-styles')) return;
    const style = document.createElement('style');
    style.id = 'ot-styles';
    style.textContent = `
      .ot-tabs-bar { display: flex; padding: 0; background: transparent; border-bottom: 2px solid #e5e7eb; margin-bottom: 1rem; }
      .ot-tab { flex: 1; padding: 0.6rem 1rem; border: none; border-bottom: 3px solid transparent; margin-bottom: -2px; background: transparent; color: #6b7280; font-size: 0.875rem; font-weight: 500; cursor: pointer; transition: all 0.2s ease; text-align: center; }
      .ot-tab:hover:not(.active) { color: #374151; border-bottom-color: #d1d5db; }
      .ot-tab.active { color: var(--primary); font-weight: 600; border-bottom-color: var(--primary); }
      .ot-tab-badge { font-size: 0.8em; opacity: 0.75; font-weight: 500; margin-left: 0.15rem; }
      .ot-tab.active .ot-tab-badge { opacity: 1; }
      @media (max-width: 640px) {
        .ot-tabs-bar { display: grid; grid-template-columns: 1fr 1fr; gap: 0.3rem; padding: 0.3rem; }
        .ot-tab { padding: 0.4rem 0.5rem; font-size: 0.75rem; }
        .ot-grid-2col { grid-template-columns: 1fr !important; }
        .ot-grid-firmas { grid-template-columns: 1fr !important; }
      }

      /* ===== Inspección Visual (compartido entre modo edit y view) ===== */
      .ot-vh-card { background: var(--bg-secondary); padding: 1rem; border-radius: 8px; }
      .ot-view-pill { display: inline-flex; flex-direction: column; align-items: center; gap: 0.05rem; background: #fff; border: 2px solid var(--primary); border-radius: 14px; padding: 0.5rem 2rem; min-width: 180px; box-shadow: 0 2px 8px rgba(37, 99, 235, 0.12); line-height: 1.2; }
      .ot-view-pill strong { font-size: 1.1rem; color: var(--primary); font-weight: 700; letter-spacing: 0.01em; }
      .ot-view-pill span { font-size: 0.75rem; color: var(--text-muted); }
      .ot-header-row { display: flex; align-items: center; justify-content: space-between; gap: 0.75rem; max-width: 480px; margin: 0 auto 0.75rem; }
      .ot-toolbar { display: flex; justify-content: center; align-items: center; flex-wrap: wrap; gap: 0.5rem; margin-bottom: 0.75rem; }
      .ot-toolbar-left { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; }
      .ot-mode-toggle { display: inline-flex; border: 1px solid var(--gray-300); border-radius: 8px; overflow: hidden; background: #fff; }
      .ot-mode-btn { padding: 0.4rem 0.75rem; border: none; background: #fff; color: var(--text-muted); font-size: 0.8rem; font-weight: 500; cursor: pointer; display: inline-flex; align-items: center; gap: 0.3rem; white-space: nowrap; transition: background 0.15s; }
      .ot-mode-btn:not(.ot-mode-active):hover { background: var(--bg-secondary); }
      .ot-mode-active { background: var(--primary); color: #fff; font-weight: 600; }
      .ot-mode-active.ot-mode-delete { background: var(--danger); }
      .ot-mode-active.ot-mode-move { background: var(--info, #0ea5e9); }
      .ot-nav-arrow { flex: 0 0 auto; width: 44px; height: 44px; border-radius: 10px; border: 1px solid var(--gray-300); background: #fff; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; line-height: 1; box-shadow: 0 1px 3px rgba(0,0,0,0.08); color: var(--text-primary, #1f2937); transition: background 0.15s; }
      .ot-nav-arrow:hover { background: var(--bg-secondary); }
      .ot-nav-arrow:active { background: var(--gray-200); }
      .ot-zoom-stack { display: inline-flex; flex-direction: column; align-items: stretch; gap: 0.1rem; background: #fff; border: 1px solid var(--gray-300); border-radius: 8px; padding: 0.15rem; }
      .ot-zoom-overlay { position: absolute; top: 0.5rem; right: 0.5rem; z-index: 5; box-shadow: 0 1px 3px rgba(0,0,0,0.12); }
      .ot-zoom-btn { width: 32px; height: 30px; border: none; background: transparent; cursor: pointer; font-size: 1.05rem; line-height: 1; border-radius: 4px; color: var(--text-primary, #1f2937); display: inline-flex; align-items: center; justify-content: center; }
      .ot-zoom-btn:hover { background: var(--bg-secondary); }
      .ot-zoom-lbl { font-size: 0.65rem; color: var(--text-muted); padding: 0.15rem 0; text-align: center; border-top: 1px solid var(--gray-200); border-bottom: 1px solid var(--gray-200); }
      .ot-mode-hint { font-size: 0.78rem; color: var(--text-muted); text-align: center; margin: 0 0 0.75rem; padding: 0.5rem 0.75rem; background: rgba(37, 99, 235, 0.05); border-left: 3px solid var(--primary); border-radius: 4px; line-height: 1.4; }
      .ot-mode-hint strong { color: var(--primary); font-weight: 600; }
      .ot-mode-hint.ot-mode-hint-delete { background: rgba(220, 38, 38, 0.05); border-left-color: var(--danger); }
      .ot-mode-hint.ot-mode-hint-delete strong { color: var(--danger); }
      .ot-mode-hint.ot-mode-hint-add { background: rgba(37, 99, 235, 0.05); border-left-color: var(--primary); }
      .ot-mode-hint.ot-mode-hint-add strong { color: var(--primary); }
      .ot-mode-hint.ot-mode-hint-move { background: rgba(14, 165, 233, 0.06); border-left-color: var(--info, #0ea5e9); }
      .ot-mode-hint.ot-mode-hint-move strong { color: var(--info, #0ea5e9); }
      @media (max-width: 600px) {
        .ot-vh-card { padding: 0.75rem 0.5rem; }
        .ot-toolbar { flex-direction: column; align-items: stretch; gap: 0.5rem; }
        .ot-mode-toggle { width: 100%; }
        .ot-mode-btn { flex: 1; justify-content: center; padding: 0.55rem 0.3rem; font-size: 0.78rem; }
        .ot-header-row { max-width: 100%; gap: 0.5rem; }
        .ot-view-pill { padding: 0.5rem 1rem; min-width: 0; flex: 1; }
        .ot-view-pill strong { font-size: 1.05rem; }
        .ot-nav-arrow { width: 42px; height: 42px; font-size: 1.4rem; }
        .ot-image-area { margin-left: -0.5rem; margin-right: -0.5rem; max-width: none !important; }
        .ot-zoom-overlay { top: 0.35rem; right: 0.35rem; }
        .ot-hint-keyboard { display: none; }
      }
    `;
    document.head.appendChild(style);
  },

  async cargarDistribuidores() {
    try {
      // Fuente unificada: usuarios activos con persona asociada.
      // El `id` del option = persona.id (FK fk_ot_distribuidor apunta a persona).
      const response = await api.get('/usuarios/responsables');
      const todos = Array.isArray(response.data) ? response.data : (response.data?.usuarios || []);
      this.data.distribuidores = todos
        .filter(u => u.persona_id)
        .map(u => ({
          id: u.persona_id,
          nombre_completo: u.persona_nombre_completo || u.nombre_completo
        }));
    } catch (error) {
      console.error('Error al cargar distribuidores:', error);
      this.data.distribuidores = [];
    }
  },

  async cargarClientes() {
    try {
      const response = await personaService.listByRol('cliente');
      if (Array.isArray(response)) {
        this.data.clientes = response;
      } else if (response.personas) {
        this.data.clientes = response.personas;
      } else if (response.data) {
        this.data.clientes = Array.isArray(response.data) ? response.data : (response.data.personas || []);
      } else {
        this.data.clientes = [];
      }
    } catch (error) {
      console.error('Error al cargar clientes:', error);
      this.data.clientes = [];
    }
  },

  async cargarResponsablesCompletar() {
    try {
      // Fuente unificada: usuarios activos con persona asociada.
      // El `id` del option = persona.id (FK en ordenes_trabajo apunta a persona).
      const response = await api.get('/usuarios/responsables');
      const todos = Array.isArray(response.data) ? response.data : (response.data?.usuarios || []);
      const responsables = todos
        .filter(u => u.persona_id)
        .map(u => ({
          id: u.persona_id,
          nombre_completo: u.persona_nombre_completo || u.nombre_completo
        }));

      // Los dos selects usan el mismo catálogo
      this.data.tecnicosServicio = responsables;
      this.data.responsablesPosventa = responsables;
    } catch (error) {
      console.error('Error al cargar responsables:', error);
      this.data.tecnicosServicio = [];
      this.data.responsablesPosventa = [];
    }
  },

  async cargarOrden(id) {
    try {
      const response = await produccionService.obtenerOrdenTrabajo(id);
      this.data.orden = response.data || response;
      this.data.isReadOnly = this.data.orden.estado === 'completada';

      // Resetear signaturePads previos: si quedaran vivos en memoria, al volver
      // a guardar se re-subirían las firmas ya persistidas. initFirmasCompletar
      // los crea nuevos para los canvases que se rendericen (firmas pendientes).
      this.signaturePadTecnico = null;
      this.signaturePadUsuario = null;
      this.signaturePadResponsable = null;

      // Inicializar estado editable (copia local de todos los datos)
      if (!this.data.isReadOnly) {
        this._initEditData();
      }

      this.renderOrdenExistente();
    } catch (error) {
      toast.error('Error al cargar orden de trabajo');
      console.error(error);
      router.navigate('/produccion/ordenes-trabajo');
    }
  },

  _initEditData() {
    const o = this.data.orden;
    // La vista es un singleton reutilizado por el router: reseteamos los buffers
    // diferidos de fotos al entrar a cada OT. Sin esto, una foto marcada para
    // borrar en una OT editada y abandonada sin guardar se eliminaría de GCS al
    // guardar OTRA OT (dejando imagen rota en la primera).
    // Ver docs/CHANGELOG_KAREN.md [2026-07-17].
    this._fotosPendientes = [];
    this._fotosEliminar = [];
    this._editData = {
      niveles: JSON.parse(JSON.stringify(o.niveles || [])),
      items_mantenimiento: JSON.parse(JSON.stringify(o.items_mantenimiento || [])),
      diagnosticos: JSON.parse(JSON.stringify(o.diagnosticos || [])),
      marcas_visuales: JSON.parse(JSON.stringify(o.marcas_visuales || [])),
      observaciones_previas: o.observaciones_previas || '',
      observaciones_posteriores: o.observaciones_posteriores || '',
      observaciones_visual: o.observaciones_visual || ''
    };
  },

  renderFormularioNuevo() {
    const container = document.getElementById('ordenContent');

    container.innerHTML = `
      <div style="padding: 1rem;">
        <!-- Búsqueda por NS -->
        <div style="border: 1px solid var(--gray-200); padding: 1.25rem; border-radius: 8px; margin-bottom: 1.5rem; background: var(--bg-secondary); box-shadow: 0 1px 3px rgba(0,0,0,0.08);">
          <div style="margin-bottom: 1rem;">
            <h4 style="margin: 0 0 0.25rem; font-size: 0.95rem; font-weight: 600;">Buscar por número de serie</h4>
            <p style="margin: 0; font-size: 0.8rem; color: var(--gray-500);">Ingrese el número de serie del tractor para cargar sus datos automáticamente</p>
          </div>
          <div style="display: flex; gap: 0.75rem; align-items: center;">
            <input type="text" id="numSerie" class="form-input" placeholder="Ej: TE354-2026-0127" style="flex: 1;" />
            <button type="button" class="btn btn-primary" onclick="window.ordenTrabajoDetalleView.buscarTractorNuevo()">Buscar</button>
          </div>
          <div id="tractorResult" style="margin-top: 1rem;"></div>
        </div>

        <form id="formOrden" onsubmit="event.preventDefault(); window.ordenTrabajoDetalleView.guardarNueva(event);">

        <!-- Formulario principal (oculto hasta encontrar tractor) -->
        <div id="formularioPrincipal" style="display: none;">

          <!-- Datos del Tractor -->
          <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
            <h4 style="margin: 0 0 1rem; font-size: 0.8rem; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; color: var(--primary); display: flex; align-items: center; gap: 0.75rem;">Datos del Tractor <span style="flex: 1; height: 2px; background: var(--gray-200);"></span></h4>
            <div class="ot-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem;">
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Marca</label>
                <input type="text" id="marcaInput" class="form-input" readonly style="background: var(--gray-50);" />
              </div>
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Modelo</label>
                <input type="text" id="modeloInput" class="form-input" readonly style="background: var(--gray-50);" />
              </div>
            </div>
            <div class="ot-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem; margin-top: 0.5rem;">
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Fecha *</label>
                <input type="date" name="fecha" class="form-input" value="${new Date().getFullYear()}-${String(new Date().getMonth()+1).padStart(2,'0')}-${String(new Date().getDate()).padStart(2,'0')}" required />
              </div>
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Tipo *</label>
                <select name="tipo" class="form-select" required>
                  <option value="mantenimiento">Mantenimiento</option>
                  <option value="reparacion">Reparación</option>
                  <option value="observacion">Observación</option>
                </select>
              </div>
            </div>
            <div class="ot-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem; margin-top: 0.5rem;">
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Horas Motor *</label>
                <input type="number" name="horas_motor" class="form-input" step="0.01" min="0" required />
              </div>
              <div id="intervaloPreviewWrap" style="display: none;">
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Intervalo</label>
                <input type="text" id="intervaloPreviewInput" class="form-input" readonly style="background: var(--gray-50);" value="" />
              </div>
            </div>
            <div class="ot-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem; margin-top: 0.5rem;">
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Distribuidor *</label>
                <select name="distribuidor_id" class="form-select" required>
                  <option value="">-- Seleccionar --</option>
                  ${this.data.distribuidores.map(d =>
                    `<option value="${d.id}">${d.nombre_completo}</option>`
                  ).join('')}
                </select>
              </div>
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Reporte CRM</label>
                <input type="text" name="reporte_crm" class="form-input" style="text-transform: uppercase;" oninput="this.value = this.value.toUpperCase()" />
              </div>
            </div>
            <div style="margin-top: 0.75rem;" id="garantiaContainer">
              <input type="checkbox" name="garantia" id="garantiaCheckCreate" value="true" style="display:none;" />
              <label id="garantiaLabel" style="display: flex; align-items: center; gap: 0.75rem; cursor: pointer;" onclick="window.ordenTrabajoDetalleView._toggleGarantiaCreate()">
                <div id="garantiaToggleCreate" style="width:44px;height:24px;border-radius:12px;background:#ccc;position:relative;transition:background 0.3s;">
                  <div id="garantiaToggleKnob" style="width:20px;height:20px;border-radius:50%;background:#fff;position:absolute;top:2px;left:2px;transition:left 0.3s;box-shadow:0 1px 3px rgba(0,0,0,0.2);"></div>
                </div>
                <span style="font-size: 0.875rem; font-weight:500;">Garantía</span>
              </label>
              <p id="garantiaMensaje" style="font-size:0.7rem;color:#dc3545;margin:0.25rem 0 0;display:none;"></p>
            </div>
          </div>

          <!-- Datos del Usuario/Cliente -->
          <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
            <h4 style="margin: 0 0 1rem; font-size: 0.8rem; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; color: var(--primary); display: flex; align-items: center; gap: 0.75rem;">Datos del Usuario <span style="flex: 1; height: 2px; background: var(--gray-200);"></span></h4>
            <div class="ot-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem;">
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Usuario / Cliente *</label>
                <div id="clienteSelectWrap" style="position:relative;">
                  <div id="clienteSelectBtn" class="form-input" style="cursor:pointer;display:flex;align-items:center;justify-content:space-between;height:38px;">
                    <span id="clienteSelectLabel" style="color:var(--gray-400);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1;">-- Seleccionar cliente --</span>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--gray-400)" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
                  </div>
                  <input type="hidden" name="nombre_usuario" id="clienteNombre" />
                  <input type="hidden" name="persona_id" id="clienteId" />
                  <div id="clienteDropdown" style="display:none;position:absolute;top:100%;left:0;right:0;background:#fff;border:1px solid var(--gray-200);border-radius:0 0 8px 8px;z-index:100;box-shadow:0 4px 16px rgba(0,0,0,0.12);">
                    <div style="padding:0.5rem;">
                      <input type="text" id="clienteSearchInput" class="form-input" placeholder="Buscar por nombre, código, RFC..." autocomplete="off" style="font-size:0.85rem;" />
                    </div>
                    <div id="clienteList" style="max-height:200px;overflow-y:auto;border-top:1px solid var(--gray-100);"></div>
                  </div>
                </div>
              </div>
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Dirección</label>
                <input type="text" name="direccion" class="form-input" />
              </div>
            </div>
          </div>

          <!-- Responsables -->
          <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
            <h4 style="margin: 0 0 1rem; font-size: 0.8rem; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; color: var(--primary); display: flex; align-items: center; gap: 0.75rem;">Responsables <span style="flex: 1; height: 2px; background: var(--gray-200);"></span></h4>
            <div class="ot-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem;">
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Técnico de Servicio *</label>
                <select name="tecnico_servicio_id" class="form-select" required>
                  <option value="">-- Seleccionar --</option>
                  ${this.data.tecnicosServicio.map(t =>
                    `<option value="${t.id}">${t.nombre_completo}</option>`
                  ).join('')}
                </select>
              </div>
              <div>
                <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Resp. Posventa *</label>
                <select name="responsable_posventa_id" class="form-select" required>
                  <option value="">-- Seleccionar --</option>
                  ${this.data.responsablesPosventa.map(r =>
                    `<option value="${r.id}">${r.nombre_completo}</option>`
                  ).join('')}
                </select>
              </div>
            </div>
          </div>

          <!-- Observaciones -->
          <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
            <h4 style="margin: 0 0 1rem; font-size: 0.8rem; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; color: var(--primary); display: flex; align-items: center; gap: 0.75rem;">Observaciones <span style="flex: 1; height: 2px; background: var(--gray-200);"></span></h4>
            <textarea name="observaciones_previas" class="form-input" rows="3" placeholder="Estado inicial, problemas reportados..."></textarea>
          </div>

          <!-- Botones -->
          <div style="display: flex; gap: 1rem; justify-content: flex-end;">
            <button type="button" class="btn btn-secondary" onclick="router.navigate('/produccion/ordenes-trabajo')">Cancelar</button>
            <button type="submit" class="btn btn-success">Crear Orden de Trabajo</button>
          </div>

        </div><!-- /formularioPrincipal -->
        </form>
      </div>
    `;

    // Enter en input de búsqueda
    document.getElementById('numSerie').addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); this.buscarTractorNuevo(); }
    });

    // Ocultar formulario si cambia el número de serie
    document.getElementById('numSerie').addEventListener('input', () => {
      if (this.data.tractor) {
        this.data.tractor = null;
        const fp = document.getElementById('formularioPrincipal');
        if (fp) {
          fp.style.display = 'none';
          delete fp.dataset.intervalBound;
        }
        document.getElementById('tractorResult').innerHTML = '';
      }
    });
  },

  async buscarTractorNuevo() {
    const numSerie = document.getElementById('numSerie').value.trim();
    if (!numSerie) return;

    const resultEl = document.getElementById('tractorResult');
    resultEl.innerHTML = '<span style="color: var(--gray-500);">Buscando tractor...</span>';

    try {
      const response = await tractorService.getByNumSerie(numSerie);
      const tractor = response.data || response;

      if (tractor && tractor.num_serie) {
        // Si ya existe una OT sin cerrar (misma regla que backend), no mostrar el formulario de alta
        let ordenesLista = [];
        try {
          const otRes = await produccionService.listarOrdenesPorTractor(tractor.num_serie);
          const raw = otRes.data != null ? otRes.data : otRes;
          ordenesLista = Array.isArray(raw) ? raw : [];
        } catch (e) {
          console.error(e);
          toast.warning('No se pudo verificar si hay ordenes abiertas. Se validara al guardar.');
        }

        const pendiente = ordenesLista.find(
          (o) => o.estado !== 'completada' && o.estado !== 'cancelada'
        );
        if (pendiente) {
          const label = `OT-${String(pendiente.id).padStart(4, '0')}`;
          this.data.tractor = null;
          resultEl.innerHTML = `
            <div style="background: #f8d7da; border: 1px solid #f5c2c7; padding: 0.75rem; border-radius: 6px; color: #842029;">
              Ya existe una orden de trabajo sin completar para este tractor (<strong>${label}</strong>). Complete esa orden antes de crear una nueva.
            </div>
          `;
          document.getElementById('formularioPrincipal').style.display = 'none';
          return;
        }

        this.data.tractor = tractor;
        resultEl.innerHTML = '';
        // Mostrar formulario y llenar datos
        document.getElementById('formularioPrincipal').style.display = 'block';
        document.getElementById('marcaInput').value = tractor.marca || '';
        document.getElementById('modeloInput').value = tractor.modelo || '';
        this._setupIntervaloPreviewNueva();
        this._setupClienteAutocomplete();
      } else {
        resultEl.innerHTML = `
          <div style="background: #fff3cd; border: 1px solid #ffc107; padding: 0.75rem; border-radius: 6px; color: #856404;">
            No se encontró un tractor con ese número de serie
          </div>
        `;
        document.getElementById('formularioPrincipal').style.display = 'none';
      }
    } catch (error) {
      resultEl.innerHTML = `
        <div style="background: #fff3cd; border: 1px solid #ffc107; padding: 0.75rem; border-radius: 6px; color: #856404;">
          No se encontró un tractor con ese número de serie
        </div>
      `;
      document.getElementById('formularioPrincipal').style.display = 'none';
      this.data.tractor = null;
    }
  },

  renderOrdenExistente() {
    const container = document.getElementById('ordenContent');
    const o = this.data.orden;

    // Actualizar botones del card-header
    const cardHeaderActions = document.getElementById('cardHeaderActions');
    if (cardHeaderActions) {
      if (o.estado === 'completada') {
        cardHeaderActions.innerHTML = `
          <button class="btn btn-secondary" onclick="router.navigate('/produccion/ordenes-trabajo')">
            &larr; Volver
          </button>
          ${permisos.canPrint('ordenes') ? `
            <button class="btn btn-primary" onclick="router.navigate('/produccion/ordenes-trabajo/${o.id}/print')">
              🖨️ Imprimir
            </button>
            <button class="btn btn-success" onclick="window.ordenTrabajoDetalleView.descargarPDF()">
              📄 Descargar PDF
            </button>
          ` : ''}
        `;
      } else {
        cardHeaderActions.innerHTML = `
          <button class="btn btn-secondary" onclick="router.navigate('/produccion/ordenes-trabajo')">
            Volver a Lista
          </button>
        `;
      }
    }

    container.innerHTML = `
      <!-- Datos del Tractor -->
      <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
        <h4 style="margin: 0 0 1rem; font-size: 0.8rem; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; color: var(--primary); display: flex; align-items: center; gap: 0.75rem;">Datos del Tractor <span style="flex: 1; height: 2px; background: var(--gray-200);"></span></h4>
        <div class="ot-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem;">
          <div>
            <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Num. Serie</label>
            <input type="text" class="form-input" value="${o.num_serie}" readonly style="background: var(--gray-50);" />
          </div>
          <div>
            <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Marca</label>
            <input type="text" class="form-input" value="${o.marca || '-'}" readonly style="background: var(--gray-50);" />
          </div>
        </div>
        <div class="ot-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem; margin-top: 0.5rem;">
          <div>
            <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Modelo</label>
            <input type="text" class="form-input" value="${o.tractor_modelo || '-'}" readonly style="background: var(--gray-50);" />
          </div>
          <div>
            <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Fecha</label>
            <input type="date" name="fecha_edit" class="form-input" value="${o.fecha ? o.fecha.substring(0, 10) : ''}" ${this.data.isReadOnly ? 'readonly style="background: var(--gray-50);"' : 'onchange="window.ordenTrabajoDetalleView._showUnsaved()"'} />
          </div>
        </div>
        <div class="ot-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem; margin-top: 0.5rem;">
          <div>
            <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Horas Motor</label>
            <input type="text" class="form-input" value="${o.horas_motor} hrs" readonly style="background: var(--gray-50);" />
          </div>
          <div>
            <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Tipo</label>
            <input type="text" class="form-input" value="${this.formatTipo(o.tipo)}" readonly style="background: var(--gray-50);" />
          </div>
        </div>
        <div class="ot-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem; margin-top: 0.5rem;">
          ${o.tipo === 'mantenimiento' ? `
          <div>
            <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Intervalo</label>
            <input type="text" class="form-input" value="${this.obtenerIntervaloEtiquetaDesdeOrden(o)} HR" readonly style="background: var(--gray-50);" />
          </div>` : ''}
          <div>
            <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Distribuidor</label>
            <input type="text" class="form-input" value="${o.distribuidor_nombre || '-'}" readonly style="background: var(--gray-50);" />
          </div>
        </div>
        <div class="ot-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem; margin-top: 0.5rem;">
          <div>
            <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Reporte CRM</label>
            <input type="text" name="reporte_crm_edit" class="form-input" value="${o.reporte_crm || ''}" style="text-transform: uppercase;${this.data.isReadOnly ? 'background: var(--gray-50);' : ''}" ${this.data.isReadOnly ? 'readonly' : 'oninput="this.value = this.value.toUpperCase(); window.ordenTrabajoDetalleView._showUnsaved()"'} />
          </div>
          <div>
            <input type="checkbox" name="garantia_edit" id="garantiaCheckEdit" ${o.garantia ? 'checked' : ''} ${this.data.isReadOnly || o.horas_motor >= 1800 ? 'disabled' : ''} onchange="window.ordenTrabajoDetalleView._showUnsaved()" style="display:none;" />
            <label style="display:flex;align-items:center;gap:0.75rem;padding:1.25rem 0 0.5rem;${this.data.isReadOnly || o.horas_motor >= 1800 ? 'opacity:0.5;cursor:not-allowed;' : 'cursor:pointer;'}" onclick="window.ordenTrabajoDetalleView._toggleGarantiaEdit()">
              <div id="garantiaToggleEdit" style="width:44px;height:24px;border-radius:12px;background:${o.garantia ? 'var(--primary)' : '#ccc'};position:relative;transition:background 0.3s;">
                <div id="garantiaKnobEdit" style="width:20px;height:20px;border-radius:50%;background:#fff;position:absolute;top:2px;left:${o.garantia ? '22px' : '2px'};transition:left 0.3s;box-shadow:0 1px 3px rgba(0,0,0,0.2);"></div>
              </div>
              <span style="font-size:0.85rem;font-weight:500;color:var(--gray-700);">Garantía</span>
            </label>
            ${!this.data.isReadOnly && o.horas_motor >= 1800 ? `<p style="font-size:0.7rem;color:#dc3545;margin:0;">El tractor tiene ${o.horas_motor} horas de motor, el límite es de 1,800 horas</p>` : ''}
          </div>
        </div>
      </div>

      <!-- Datos del Usuario -->
      <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
        <h4 style="margin: 0 0 1rem; font-size: 0.8rem; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; color: var(--primary); display: flex; align-items: center; gap: 0.75rem;">Datos del Usuario <span style="flex: 1; height: 2px; background: var(--gray-200);"></span></h4>
        <div class="ot-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem;">
          <div>
            <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Usuario / Cliente</label>
            <input type="text" class="form-input" value="${o.nombre_usuario}" readonly style="background: var(--gray-50);" />
          </div>
          <div>
            <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Dirección</label>
            <input type="text" class="form-input" value="${o.direccion || '-'}" readonly style="background: var(--gray-50);" />
          </div>
        </div>
      </div>


      <!-- Tabs -->
      <div class="ot-tabs-bar">
        <button class="ot-tab active" onclick="window.ordenTrabajoDetalleView.showTab('niveles-previos')">
          Niveles Previos
        </button>
        <button class="ot-tab" onclick="window.ordenTrabajoDetalleView.showTab('inspeccion-visual')">
          Inspección Visual<span class="ot-tab-badge" id="otTabInspBadge">${(o.marcas_visuales || []).length > 0 ? ` (${(o.marcas_visuales || []).length})` : ''}</span>
        </button>
        <button class="ot-tab" onclick="window.ordenTrabajoDetalleView.showTab('mantenimiento')">
          Checklist Mantenimiento
        </button>
        <button class="ot-tab" onclick="window.ordenTrabajoDetalleView.showTab('diagnosticos')">
          Diagnósticos
        </button>
        <button class="ot-tab" onclick="window.ordenTrabajoDetalleView.showTab('niveles-posteriores')">
          Niveles Posteriores
        </button>
        <button class="ot-tab" onclick="window.ordenTrabajoDetalleView.showTab('firmas')">
          Firmas
        </button>
      </div>

      <!-- Tab Content -->
      <div id="tabContent" style="margin-bottom: 1.5rem;">
        ${this.renderTabNivelesMomento('previo', 'Niveles de Fluidos - Previo')}
      </div>

      ${!this.data.isReadOnly ? `
        <div id="unsavedIndicator" style="display: none; background: var(--warning); color: white; padding: 0.5rem 1rem; border-radius: 8px; margin-bottom: 1rem; text-align: center;">
          Hay cambios sin guardar
        </div>
        <div style="display: flex; gap: 0.5rem; justify-content: flex-end; flex-wrap: wrap;">
          <button class="btn btn-primary" onclick="window.ordenTrabajoDetalleView.guardarCambios()">
            Guardar Cambios
          </button>
          ${o.estado === 'abierta' && permisos.can('ordenes', 'cerrar') ? `
            <button class="btn btn-success" onclick="window.ordenTrabajoDetalleView.completarOrden()">
              Completar Orden
            </button>
          ` : ''}
        </div>
      ` : ''}

    `;

    this._injectStyles();
  },

  showTab(tab) {
    this._currentTab = tab;

    // Recolectar datos del tab actual antes de cambiar (textareas)
    this._collectCurrentTabData();

    // Actualizar botones activos
    document.querySelectorAll('.ot-tab').forEach(btn => btn.classList.remove('active'));
    const tabButton = document.querySelector(`.ot-tab[onclick*="'${tab}'"]`);
    if (tabButton) tabButton.classList.add('active');

    const content = document.getElementById('tabContent');

    switch(tab) {
      case 'niveles-previos':
        content.innerHTML = this.renderTabNivelesMomento('previo', 'Niveles de Fluidos - Previo');
        break;
      case 'niveles-posteriores':
        content.innerHTML = this.renderTabNivelesMomento('posterior', 'Niveles de Fluidos - Posterior');
        break;
      case 'mantenimiento':
        content.innerHTML = this.renderTabMantenimiento();
        break;
      case 'inspeccion-visual':
        content.innerHTML = this.renderTabInspeccionVisual();
        this._initInspeccionVisual();
        break;
      case 'diagnosticos':
        content.innerHTML = this.renderTabDiagnosticos();
        break;
      case 'observaciones':
        content.innerHTML = this.renderTabObservaciones();
        break;
      case 'firmas':
        content.innerHTML = this.renderTabFirmas();
        if (!this.data.isReadOnly) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => this.initFirmasTab());
          });
        }
        break;
    }
  },

  // Mapeo de los 10 fluidos oficiales: display → key backend
  FLUIDOS_MAP: [
    { display: 'Nivel de Combustible', key: 'combustible' },
    { display: 'Nivel de Anticongelante', key: 'anticongelante' },
    { display: 'Nivel de Aceite de Sistema Hidráulico', key: 'aceite_sistema_hidraulico' },
    { display: 'Nivel de Aceite de Motor', key: 'aceite_motor' },
    { display: 'Nivel de Aceite de Transmisión', key: 'aceite_transmision' },
    { display: 'Nivel de Aceite de Sistema de Dirección', key: 'aceite_sistema_direccion' },
    { display: 'Nivel de Aceite de Frenos', key: 'aceite_frenos' },
    { display: 'Nivel de Aceite de Eje Delantero', key: 'aceite_eje_delantero' },
    { display: 'Nivel de Aceite de Maza Izquierda', key: 'aceite_maza_izquierda' },
    { display: 'Nivel de Aceite de Maza Derecha', key: 'aceite_maza_derecha' }
  ],

  // Mapeo segmento (1-7) → nivel_visual del backend
  SEGMENTO_A_NIVEL: {
    1: 'min',
    2: 'bajo',
    3: 'medio_bajo',
    4: 'medio',
    5: 'medio_alto',
    6: 'alto',
    7: 'max'
  },

  // Inverso: nivel_visual → segmento
  NIVEL_A_SEGMENTO: {
    'min': 1,
    'bajo': 2,
    'medio_bajo': 3,
    'medio': 4,
    'medio_alto': 5,
    'alto': 6,
    'max': 7
  },

  // Colores por segmento para cada fluido (solo los que tienen color)
  // 'red' = zona peligrosa, 'green' = zona óptima, sin entrada = neutro/blanco
  FLUIDOS_COLORES: {
    combustible:               { 1:'red', 4:'yellow', 7:'green' },
    anticongelante:            { 1:'red', 4:'green', 5:'green', 7:'red' },
    aceite_sistema_hidraulico: { 1:'red', 4:'green', 5:'green', 7:'red' },
    aceite_motor:              { 1:'red', 4:'green', 5:'green', 7:'red' },
    aceite_transmision:        { 1:'red', 4:'green', 5:'green', 7:'red' },
    aceite_sistema_direccion:  { 1:'red', 4:'green', 5:'green', 7:'red' },
    aceite_frenos:             { 1:'red', 4:'green', 5:'green', 7:'red' },
    aceite_eje_delantero:      { 1:'red', 4:'green', 5:'green', 7:'red' },
    aceite_maza_izquierda:     { 1:'red', 4:'green', 7:'red' },
    aceite_maza_derecha:       { 1:'red', 4:'green', 7:'red' }
  },

  // Niveles que NO aplican para el modelo de la orden. Config DINÁMICA: viene del
  // backend (columna `modelos.niveles_no_aplican`, compartida con el Check List de
  // Ensamble) ya resuelta en `orden.niveles_no_aplican`.
  _nivelesNoAplican() {
    const na = this.data.orden?.niveles_no_aplican;
    return Array.isArray(na) ? na : [];
  },

  // Fluidos que sí deben capturarse para este modelo (base de los gates de completar).
  _fluidosAplicables() {
    const noAplican = this._nivelesNoAplican();
    return this.FLUIDOS_MAP.filter(f => !noAplican.includes(f.key));
  },

  renderNivelBar(fluidoKey, fluidoDisplay, momento, segmentoActivo, noAplica = false) {
    // Nivel que no aplica para este modelo: se muestra tachado, gris y no editable.
    if (noAplica) {
      return `
        <div class="nivel-bar" style="opacity:0.6;">
          <div class="nivel-bar-title" style="text-decoration:line-through;color:var(--gray-400);">${fluidoDisplay}</div>
          <div style="text-align:center;padding:0.9rem 0;color:#6c757d;font-weight:700;font-size:0.85rem;">No aplica</div>
        </div>
      `;
    }
    const isReadOnly = this.data.isReadOnly;
    const colores = this.FLUIDOS_COLORES[fluidoKey] || {};
    const segments = [1, 2, 3, 4, 5, 6, 7].map(seg => {
      const isActive = segmentoActivo === seg;
      const disabledClass = isReadOnly ? 'disabled' : '';
      const activeClass = isActive ? 'active' : '';
      const colorClass = colores[seg] ? `seg-${colores[seg]}` : '';
      const onclick = isReadOnly ? '' : `onclick="window.ordenTrabajoDetalleView.onSegmentClick('${fluidoKey}', '${momento}', ${seg})"`;
      return `<div class="nivel-segment ${colorClass} ${activeClass} ${disabledClass}" ${onclick} title="Segmento ${seg}"></div>`;
    }).join('');

    return `
      <div class="nivel-bar">
        <div class="nivel-bar-title">${fluidoDisplay}</div>
        <div class="nivel-segments">
          ${segments}
        </div>
        <div class="nivel-labels">
          <span>Min</span>
          <span>Max</span>
        </div>
      </div>
    `;
  },

  renderTabNivelesMomento(momento, titulo) {
    const o = this.data.orden;
    const niveles = (!this.data.isReadOnly && this._editData) ? this._editData.niveles : (o.niveles || []);

    const noAplican = this._nivelesNoAplican();

    const getSegmento = (key) => {
      const nivel = niveles.find(n => n.tipo_fluido === key && n.momento === momento);
      if (!nivel) return 0;
      return this.NIVEL_A_SEGMENTO[nivel.nivel_visual] || 0;
    };

    return `
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
        <h4 style="margin-bottom: 1rem;">${titulo}</h4>
        <div class="nivel-fluidos-grid">
          ${this.FLUIDOS_MAP.map(f =>
            this.renderNivelBar(f.key, f.display, momento, getSegmento(f.key), noAplican.includes(f.key))
          ).join('')}
        </div>
      </div>
    `;
  },

  renderTabNiveles() {
    const o = this.data.orden;
    const niveles = (!this.data.isReadOnly && this._editData) ? this._editData.niveles : (o.niveles || []);

    const noAplican = this._nivelesNoAplican();

    const getSegmento = (key, momento) => {
      const nivel = niveles.find(n => n.tipo_fluido === key && n.momento === momento);
      if (!nivel) return 0;
      return this.NIVEL_A_SEGMENTO[nivel.nivel_visual] || 0;
    };

    const renderMomento = (momento, label) => {
      return `
        <div style="flex: 1;">
          <h5 style="margin-bottom: 0.75rem; color: var(--primary);">${label}</h5>
          <div class="nivel-fluidos-grid">
            ${this.FLUIDOS_MAP.map(f =>
              this.renderNivelBar(f.key, f.display, momento, getSegmento(f.key, momento), noAplican.includes(f.key))
            ).join('')}
          </div>
        </div>
      `;
    };

    return `
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
        <h4 style="margin-bottom: 1rem;">Niveles de Fluidos</h4>
        <div style="display: flex; gap: 1.5rem; flex-wrap: wrap;">
          ${renderMomento('previo', 'Previo')}
          ${renderMomento('posterior', 'Posterior')}
        </div>
      </div>
    `;
  },

  onSegmentClick(fluidoKey, momento, segmento) {
    const nivelVisual = this.SEGMENTO_A_NIVEL[segmento];
    if (!nivelVisual || !this._editData) return;

    // Update local state
    const existente = this._editData.niveles.find(n => n.tipo_fluido === fluidoKey && n.momento === momento);
    if (existente) {
      existente.nivel_visual = nivelVisual;
    } else {
      this._editData.niveles.push({ tipo_fluido: fluidoKey, momento, nivel_visual: nivelVisual });
    }

    // Re-render tab actual
    const content = document.getElementById('tabContent');
    const titulo = momento === 'previo' ? 'Niveles de Fluidos - Previo' : 'Niveles de Fluidos - Posterior';
    if (content) content.innerHTML = this.renderTabNivelesMomento(momento, titulo);
    this._showUnsaved();
  },

  // Modelos válidos para checklist de mantenimiento
  MODELOS_VALIDOS: ['TE254', 'TE354', 'TB504', 'TH754', 'TD904', 'TD1104', 'TR1504'],

  _isModeloAplica() {
    const o = this.data.orden;
    return this.MODELOS_VALIDOS.includes(o.tractor_modelo);
  },

  renderTabMantenimiento() {
    const o = this.data.orden;
    const items = (!this.data.isReadOnly && this._editData) ? this._editData.items_mantenimiento : (o.items_mantenimiento || []);

    return `
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
        ${!this._isModeloAplica() && items.length === 0 ? `
          <div style="text-align: center; padding: 2rem;">
            <span class="badge badge-secondary" style="font-size: 0.9rem; padding: 0.5rem 1.5rem;">No aplica</span>
            <p style="color: var(--text-muted); margin-top: 0.5rem; font-size: 0.85rem;">
              El modelo ${o.tractor_modelo || 'desconocido'} no tiene checklist de mantenimiento estándar
            </p>
          </div>
        ` : items.length === 0 ? `
          <p style="text-align: center; color: var(--text-muted); padding: 2rem;">
            No hay items de mantenimiento registrados
          </p>
        ` : `
          <div class="table-container">
            <table class="table">
              <thead>
                <tr>
                  <th></th>
                  <th>#</th>
                  <th>Descripción</th>
                  <th class="tbl-hide-mobile">Acción</th>
                  <th class="tbl-hide-mobile">Realizado</th>
                </tr>
              </thead>
              <tbody>
                ${items.map(item => {
                  const checkboxHtml = `<input type="checkbox" ${item.realizado ? 'checked' : ''} ${this.data.isReadOnly ? 'disabled' : ''} onchange="window.ordenTrabajoDetalleView.toggleItemRealizado(${item.id}, this.checked)" />`;
                  return `
                  <tr>
                    <td><button class="tbl-expand-btn" onclick="window.ordenTrabajoDetalleView.toggleItemRow(${item.id})">&#9654;</button></td>
                    <td>${item.item_numero}</td>
                    <td>${item.descripcion}</td>
                    <td class="tbl-hide-mobile"><span class="badge badge-secondary">${item.accion}</span></td>
                    <td class="tbl-hide-mobile">${checkboxHtml}</td>
                  </tr>
                  <tr class="tbl-detail-row" id="detail-item-${item.id}">
                    <td colspan="5" class="tbl-detail-cell">
                      <dl class="tbl-detail-grid">
                        <dt>Acción</dt><dd><span class="badge badge-secondary">${item.accion}</span></dd>
                        <dt>Realizado</dt><dd>${checkboxHtml}</dd>
                      </dl>
                    </td>
                  </tr>
                `}).join('')}
              </tbody>
            </table>
          </div>
        `}
      </div>
    `;
  },

  renderTabDiagnosticos() {
    const o = this.data.orden;
    const diagnosticos = (!this.data.isReadOnly && this._editData) ? this._editData.diagnosticos : (o.diagnosticos || []);

    return `
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
          <h4 style="margin: 0; font-size: 0.95rem; color: var(--gray-700);">Diagnósticos y soluciones</h4>
          ${!this.data.isReadOnly ? `
            <button class="btn btn-sm" style="border:1px solid var(--gray-300);background:#fff;color:var(--gray-700);font-weight:600;" onclick="window.ordenTrabajoDetalleView.agregarDiagnostico()">
              Agregar diagnóstico
            </button>
          ` : ''}
        </div>
        ${diagnosticos.length === 0 ? `
          <p style="text-align: center; color: var(--text-muted); padding: 2rem;">
            No hay diagnósticos registrados
          </p>
        ` : `
          <div style="display: grid; gap: 0.75rem;">
            ${diagnosticos.map((d, i) => `
              <div style="background:#fff;padding:1rem;border-radius:10px;border:1px solid var(--gray-200);display:flex;align-items:flex-start;gap:0.75rem;">
                <div style="min-width:24px;height:24px;border-radius:50%;background:var(--primary);color:#fff;display:flex;align-items:center;justify-content:center;font-size:0.7rem;font-weight:700;margin-top:2px;">${i + 1}</div>
                <div style="flex:1;">
                  <div style="font-size:0.9rem;font-weight:600;color:var(--gray-800);margin-bottom:0.15rem;">${d.diagnostico || '-'}</div>
                  <div style="font-size:0.8rem;color:var(--gray-500);margin-bottom:0.5rem;">${d.solucion || 'Sin solución registrada'}</div>
                  <div style="display:flex;gap:0.5rem;flex-wrap:wrap;">
                    ${d.codigo_parte ? `<span style="font-size:0.7rem;background:var(--gray-100);color:var(--gray-600);padding:0.2rem 0.5rem;border-radius:4px;font-weight:500;">P/N: ${d.codigo_parte}</span>` : ''}
                    ${d.accion ? `<span style="font-size:0.7rem;background:var(--gray-200);color:var(--gray-700);padding:0.2rem 0.5rem;border-radius:4px;font-weight:500;">${d.accion}</span>` : ''}
                    ${d.cantidad ? `<span style="font-size:0.7rem;background:var(--gray-100);color:var(--gray-600);padding:0.2rem 0.5rem;border-radius:4px;font-weight:500;">Cant: ${d.cantidad}</span>` : ''}
                  </div>
                </div>
                ${!this.data.isReadOnly ? `
                  <button style="background:none;border:none;color:var(--gray-400);cursor:pointer;font-size:1.1rem;padding:0;line-height:1;" onclick="window.ordenTrabajoDetalleView.eliminarDiagnostico(${d.id})" title="Eliminar">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                  </button>
                ` : ''}
              </div>
            `).join('')}
          </div>
        `}
      </div>
    `;
  },

  renderTabFirmas() {
    const o = this.data.orden;

    // Modo readonly: mostrar firmas como en Recepción Visual
    if (this.data.isReadOnly) {
      return `
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
          <div id="firmasContainer" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.5rem;" class="ot-grid-firmas">
            ${this._renderFirmaLectura('Técnico de Servicio', o.tecnico_servicio, o.tecnico_servicio_firma_url)}
            ${this._renderFirmaLectura('Usuario', o.nombre_usuario, o.usuario_firma_url)}
            ${this._renderFirmaLectura('Responsable Posventa', o.responsable_posventa, o.responsable_posventa_firma_url)}
          </div>
          ${o.observaciones_posteriores ? `
            <div style="margin-top: 1rem; padding: 0.75rem; background: white; border-radius: 8px; border: 1px solid var(--gray-200);">
              <label style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;">Observaciones Finales</label>
              <p style="margin: 0; color: var(--gray-700);">${o.observaciones_posteriores}</p>
            </div>
          ` : ''}
        </div>
      `;
    }

    // Modo edición: mismo formato que Recepción Visual
    return `
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
        <div id="firmasContainer" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.5rem; margin-bottom: 1rem;" class="ot-grid-firmas">
          ${this._renderFirmaEdicion('tecnico', 'Técnico de Servicio', o.tecnico_servicio_firma_url)}
          ${this._renderFirmaEdicion('usuario', 'Usuario', o.usuario_firma_url)}
          ${this._renderFirmaEdicion('responsable', 'Responsable Posventa', o.responsable_posventa_firma_url)}
        </div>

        <div class="form-group">
          <label class="form-label">Observaciones Finales</label>
          <textarea id="observacionesFinales" class="form-input" rows="3"
            placeholder="Observaciones al finalizar el trabajo..."
            onchange="window.ordenTrabajoDetalleView._onFirmasChange()">${this._editData?.observaciones_posteriores || ''}</textarea>
        </div>
      </div>
    `;
  },

  _renderFirmaLectura(label, nombre, url) {
    return `
      <div style="text-align: center; padding: 0.5rem;">
        <div style="min-height: 150px; display: flex; align-items: center; justify-content: center;">
          ${url
            ? `<img src="${url}" style="width: 100%; max-height: 150px; object-fit: contain;" onerror="this.style.display='none'" />`
            : '<span style="color: var(--text-secondary);">Sin firma</span>'
          }
        </div>
        <hr style="border: none; border-top: 3px solid #000; margin: 0.5rem 0;" />
        <p style="margin: 0.25rem 0 0; font-weight: 600; font-size: 0.85rem;">${nombre || '-'}</p>
        <p style="margin: 0.25rem 0 0; color: var(--text-secondary); font-size: 0.8rem;">${label}</p>
      </div>
    `;
  },

  _renderFirmaEdicion(tipo, label, existingUrl) {
    const o = this.data.orden;
    const nombreMap = {
      tecnico: o.tecnico_servicio || '-',
      usuario: o.nombre_usuario || '-',
      responsable: o.responsable_posventa || '-'
    };
    const nombre = nombreMap[tipo];

    if (existingUrl) {
      return `
        <div style="border: 1px solid var(--gray-200); border-radius: 8px; overflow: hidden; background: white;">
          <div style="background: var(--bg-secondary); padding: 0.6rem; text-align: center; border-bottom: 1px solid var(--gray-200);">
            <span style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; color: var(--primary); font-weight: 600;">${label} *</span>
          </div>
          <div style="padding: 1.5rem; text-align: center;">
            <img src="${existingUrl}" style="width: 100%; max-height: 100px; object-fit: contain;" onerror="this.style.display='none'" />
          </div>
          <div style="padding: 0 1rem 0.25rem; text-align: center;">
            <a href="javascript:void(0)" style="font-size: 0.8rem; color: var(--primary);" onclick="window.ordenTrabajoDetalleView.cambiarFirmaExistente('${tipo}')">Cambiar firma</a>
          </div>
          <div style="padding: 0.5rem 1rem 0.75rem; border-top: 1px solid var(--gray-200);">
            <span style="font-size: 0.7rem; color: var(--gray-500); text-transform: uppercase; letter-spacing: 0.5px;">Nombre</span>
            <p style="margin: 0.15rem 0 0; font-weight: 600; font-size: 0.85rem;">${nombre}</p>
          </div>
        </div>
      `;
    }
    return `
      <div style="border: 1px solid var(--gray-200); border-radius: 8px; overflow: hidden; background: white;">
        <div style="background: var(--bg-secondary); padding: 0.6rem; text-align: center; border-bottom: 1px solid var(--gray-200);">
          <span style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; color: var(--primary); font-weight: 600;">${label} *</span>
        </div>
        <div class="firma-box" style="position: relative;">
          <canvas id="firma-${tipo}" class="firma-canvas-new"></canvas>
          <span class="firma-placeholder" id="firma-placeholder-${tipo}" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center; pointer-events: none; color: var(--gray-400);">
            <span style="font-size: 0.8rem;">Firme aquí</span>
          </span>
        </div>
        <div style="padding: 0 1rem 0.25rem; text-align: center;">
          <a href="javascript:void(0)" style="font-size: 0.8rem; color: var(--primary);" onclick="window.ordenTrabajoDetalleView.limpiarFirmaCompletar('${tipo}')">Limpiar</a>
        </div>
        <div style="padding: 0.5rem 1rem 0.75rem; border-top: 1px solid var(--gray-200);">
          <span style="font-size: 0.7rem; color: var(--gray-500); text-transform: uppercase; letter-spacing: 0.5px;">Nombre</span>
          <p style="margin: 0.15rem 0 0; font-weight: 600; font-size: 0.85rem;">${nombre}</p>
        </div>
      </div>
    `;
  },

  cambiarFirmaExistente(tipo) {
    const o = this.data.orden;
    const urlMap = {
      tecnico: 'tecnico_servicio_firma_url',
      usuario: 'usuario_firma_url',
      responsable: 'responsable_posventa_firma_url'
    };
    o[urlMap[tipo]] = null;
    this._renderFirmasDinamicas();
    this.initFirmasCompletar();
    this._showUnsaved();
  },

  _renderFirmasDinamicas() {
    const container = document.getElementById('firmasContainer');
    if (!container) return;
    const o = this.data.orden;
    container.innerHTML = `
      ${this._renderFirmaEdicion('tecnico', 'Técnico de Servicio', o.tecnico_servicio_firma_url)}
      ${this._renderFirmaEdicion('usuario', 'Usuario', o.usuario_firma_url)}
      ${this._renderFirmaEdicion('responsable', 'Responsable Posventa', o.responsable_posventa_firma_url)}
    `;
  },

  initFirmasTab() {
    // Cargar SignaturePad si no está disponible
    if (typeof SignaturePad !== 'undefined') {
      this.initFirmasCompletar();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/signature_pad/4.1.7/signature_pad.umd.min.js';
    script.onload = () => this.initFirmasCompletar();
    script.onerror = () => {
      toast.error('Error al cargar módulo de firmas. Recargue la página.');
    };
    document.head.appendChild(script);
  },

  _onFirmasChange() {
    if (this._editData) {
      this._editData.observaciones_posteriores = document.getElementById('observacionesFinales')?.value || null;
    }
    this._showUnsaved();
  },

  renderTabObservaciones() {
    const o = this.data.orden;
    const obsPrev = (!this.data.isReadOnly && this._editData) ? this._editData.observaciones_previas : (o.observaciones_previas || '');
    const obsPost = (!this.data.isReadOnly && this._editData) ? this._editData.observaciones_posteriores : (o.observaciones_posteriores || '');

    return `
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
        <div class="form-group" style="margin-bottom: 1rem;">
          <label class="form-label">Observaciones Previas</label>
          <textarea
            id="observacionesPrevias"
            class="form-input"
            rows="4"
            ${this.data.isReadOnly ? 'readonly' : ''}
          >${obsPrev}</textarea>
        </div>
        <div class="form-group">
          <label class="form-label">Observaciones Posteriores</label>
          <textarea
            id="observacionesPosteriores"
            class="form-input"
            rows="4"
            ${this.data.isReadOnly ? 'readonly' : ''}
          >${obsPost}</textarea>
        </div>
      </div>
    `;
  },

  renderTabInspeccionVisual() {
    const o = this.data.orden;
    const isReadOnly = this.data.isReadOnly;

    if (isReadOnly) {
      const marcas = Array.isArray(o.marcas_visuales) ? o.marcas_visuales : [];
      this._marcasVisuales = marcas;
      return this._renderInspeccionVisualView(o, marcas);
    }

    // In edit mode, point to _editData array (same reference for push/splice)
    this._marcasVisuales = this._editData.marcas_visuales;
    return this._renderInspeccionVisualEdit(o);
  },

  _renderInspeccionVisualView(o, marcas) {
    const slides = ['tractor-frente', 'tractor-trasera', 'tractor-lateral-izq', 'tractor-lateral-der'];
    const altMap = { 'tractor-frente': 'Parte Frontal', 'tractor-trasera': 'Parte Trasera', 'tractor-lateral-izq': 'Lateral Izquierdo', 'tractor-lateral-der': 'Lateral Derecho' };
    const idSuffixMap = { 'tractor-frente': 'Frente', 'tractor-trasera': 'Trasera', 'tractor-lateral-izq': 'LatIzq', 'tractor-lateral-der': 'LatDer' };

    return `
      <div class="ot-vh-card">
        <!-- Header con flechas a los extremos y pill en el centro:
             [‹]   Frontal / 2/4 vistas   [›]
             (Sin toolbar de modos — vista read-only.) -->
        <div class="ot-header-row">
          <button type="button" class="ot-nav-arrow" aria-label="Vista anterior" onclick="window.ordenTrabajoDetalleView._navOTViewSlide(-1)">‹</button>
          <div class="ot-view-pill">
            <strong id="otViewTitleRO">Frontal</strong>
          </div>
          <button type="button" class="ot-nav-arrow" aria-label="Vista siguiente" onclick="window.ordenTrabajoDetalleView._navOTViewSlide(1)">›</button>
        </div>

        <!-- Hint corto para read-only: explica que se puede tocar un punto
             para ver su foto (sin opción a editar). -->
        <p class="ot-mode-hint ot-mode-hint-move">💡 Arrastra la imagen para moverte · Toca un punto marcado para ver su foto</p>

        <!-- Image area: zoom overlay + slides. Misma estética que el modo edit. -->
        <div class="ot-image-area" style="position:relative;max-width:1000px;margin:0 auto;">
          <div class="ot-zoom-stack ot-zoom-overlay">
            <button type="button" class="ot-zoom-btn" aria-label="Aumentar zoom" onclick="window.ordenTrabajoDetalleView._zoomOTViewActive(1)">+</button>
            <span id="otViewZoomLabelActive" class="ot-zoom-lbl">100%</span>
            <button type="button" class="ot-zoom-btn" aria-label="Reducir zoom" onclick="window.ordenTrabajoDetalleView._zoomOTViewActive(-1)">−</button>
          </div>
          ${slides.map((key, i) => {
            const idSuffix = idSuffixMap[key];
            const altText = altMap[key];
            return `
              <div id="otViewSlide-${key}" style="display:${i === 0 ? 'block' : 'none'};">
                <div id="otViewScroll${idSuffix}" style="overflow: hidden; border: 1px solid var(--gray-300); border-radius: 8px; background: #fff; text-align: center;">
                  <div style="position: relative; display: inline-block;">
                    <img id="otViewImg${idSuffix}" src="/img/${key}.jpeg" alt="${altText}" style="display: block; width: 100%;" draggable="false" />
                    <canvas id="otViewCanvas${idSuffix}" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none;"></canvas>
                  </div>
                </div>
              </div>
            `;
          }).join('')}
        </div>

        <p class="ot-hint-keyboard" style="font-size:0.75rem;color:var(--text-muted);text-align:center;margin-top:0.5rem;">⌨️ También puedes usar las flechas ← → del teclado</p>

        <div style="margin-top: 1rem; padding-top: 0.75rem; border-top: 1px solid var(--gray-300);">
          <h4 style="margin-bottom: 0.5rem; font-size: 0.9rem;">Observaciones</h4>
          ${o.observaciones_visual
            ? `<p style="background: var(--bg-primary); padding: 0.75rem; border-radius: 6px; border-left: 3px solid var(--primary);">${o.observaciones_visual}</p>`
            : '<p style="color: var(--text-muted); font-style: italic;">Sin observaciones de inspección visual</p>'
          }
        </div>
      </div>
    `;
  },

  _renderInspeccionVisualEdit(o) {
    const slides = ['tractor-frente', 'tractor-trasera', 'tractor-lateral-izq', 'tractor-lateral-der'];
    const altMap = { 'tractor-frente': 'Parte Frontal', 'tractor-trasera': 'Parte Trasera', 'tractor-lateral-izq': 'Lateral Izquierdo', 'tractor-lateral-der': 'Lateral Derecho' };
    const idSuffixMap = { 'tractor-frente': 'Frente', 'tractor-trasera': 'Trasera', 'tractor-lateral-izq': 'LatIzq', 'tractor-lateral-der': 'LatDer' };

    return `
      <div class="ot-vh-card">
        <!-- Header con flechas a los extremos y pill grande en el centro:
             [‹]              [ Frontal / 2/4 vistas ]              [›]
             Toda la navegación en una sola fila ancha y prominente. -->
        <div class="ot-header-row">
          <button type="button" class="ot-nav-arrow" aria-label="Vista anterior" onclick="window.ordenTrabajoDetalleView._navOTSlide(-1)">‹</button>
          <div class="ot-view-pill">
            <strong id="otViewTitle">Frontal</strong>
          </div>
          <button type="button" class="ot-nav-arrow" aria-label="Vista siguiente" onclick="window.ordenTrabajoDetalleView._navOTSlide(1)">›</button>
        </div>

        <!-- Toolbar: solo el toggle de modo. El zoom flota en la esquina
             superior derecha de la imagen y el contador de marcas vive en el
             badge del tab "Inspección Visual" — no se duplica info aquí. -->
        <div class="ot-toolbar">
          <div class="ot-mode-toggle">
            <button type="button" id="otModeMov" class="ot-mode-btn ot-mode-move ot-mode-active" onclick="window.ordenTrabajoDetalleView._setMarkModeOT(window.ordenTrabajoDetalleView._activeOTSlide, 'move')">🤚 Mover</button>
            <button type="button" id="otModeAdd" class="ot-mode-btn ot-mode-add" onclick="window.ordenTrabajoDetalleView._setMarkModeOT(window.ordenTrabajoDetalleView._activeOTSlide, 'add')">📍 Marcar</button>
            <button type="button" id="otModeDel" class="ot-mode-btn ot-mode-delete" onclick="window.ordenTrabajoDetalleView._setMarkModeOT(window.ordenTrabajoDetalleView._activeOTSlide, 'delete')">🗑 Eliminar</button>
          </div>
        </div>

        <!-- Hint contextual: cambia su contenido según el modo activo.
             Contenedor vacío; el JS (_updateModeHint) lo llena al inicializar
             y al cambiar de modo. Fuente única de verdad para los textos. -->
        <p id="otModeHint" class="ot-mode-hint"></p>

        <!-- Image area: la imagen ocupa todo el ancho disponible. Las flechas
             de navegación viven en el header (junto al pill). El zoom widget
             flota en la esquina superior derecha de la imagen. -->
        <div class="ot-image-area" style="position:relative;max-width:1000px;margin:0 auto;">
          <!-- Zoom widget vertical en esquina superior derecha, sobre la imagen.
               + arriba, − abajo (patrón Google Maps). -->
          <div class="ot-zoom-stack ot-zoom-overlay">
            <button type="button" class="ot-zoom-btn" aria-label="Aumentar zoom" onclick="window.ordenTrabajoDetalleView._zoomOTActive(1)">+</button>
            <span id="otZoomLabelActive" class="ot-zoom-lbl">100%</span>
            <button type="button" class="ot-zoom-btn" aria-label="Reducir zoom" onclick="window.ordenTrabajoDetalleView._zoomOTActive(-1)">−</button>
          </div>
          ${slides.map((key, i) => {
            const idSuffix = idSuffixMap[key];
            const altText = altMap[key];
            return `
              <div id="otEditSlide-${key}" style="display:${i === 0 ? 'block' : 'none'};">
                <div id="otScroll${idSuffix}" style="overflow: hidden; border: 1px solid var(--gray-300); border-radius: 8px; background: #fff; text-align: center;">
                  <div id="otWrap${idSuffix}" style="position: relative; display: inline-block; cursor: grab;">
                    <img id="otImg${idSuffix}" src="/img/${key}.jpeg" alt="${altText}" style="display: block; width: 100%;" draggable="false" />
                    <canvas id="otCanvas${idSuffix}" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; touch-action: auto; user-select: none; -webkit-user-select: none; pointer-events: auto;"></canvas>
                  </div>
                </div>
              </div>
            `;
          }).join('')}
        </div>

        <p class="ot-hint-keyboard" style="font-size:0.75rem;color:var(--text-muted);text-align:center;margin-top:0.5rem;">⌨️ También puedes usar las flechas ← → del teclado</p>
        <p style="font-size: 0.75rem; color: var(--text-muted); text-align: center; margin-top: 0.25rem;">*El diagrama es ilustrativo, y las características del tractor pueden variar según modelo.</p>

        <div style="margin-top: 1rem;">
          <label class="form-label">Observaciones de inspección visual</label>
          <textarea id="otObservacionesVisual" class="form-input" rows="4" placeholder="Describa hallazgos de la inspección visual...">${this._editData?.observaciones_visual || ''}</textarea>
        </div>
      </div>
    `;
  },

  _initInspeccionVisual() {
    this._zoomLevels = { 'tractor-frente': 1, 'tractor-trasera': 1, 'tractor-lateral-izq': 1, 'tractor-lateral-der': 1 };
    // Modo default: "move" — el usuario navega primero y switchea a "marcar"
    // cuando está listo. Reduce marcas accidentales y refleja el flujo natural.
    this._markMode = { 'tractor-frente': 'move', 'tractor-trasera': 'move', 'tractor-lateral-izq': 'move', 'tractor-lateral-der': 'move' };
    // Slide activo actual — usado por toggle/zoom/arrows del header unificado.
    this._activeOTSlide = 'tractor-frente';
    this._otSlidesOrder = ['tractor-frente', 'tractor-trasera', 'tractor-lateral-izq', 'tractor-lateral-der'];

    if (this.data.isReadOnly) {
      this._activeOTViewSlide = 'tractor-frente';
      const marcas = this._marcasVisuales || [];
      // Header se actualiza inmediatamente para que el contador "Y/4 vistas"
      // se vea correcto al instante, sin esperar al setTimeout del dibujo.
      this._updateOTViewHeader();
      setTimeout(() => {
        if (marcas.length > 0) {
          this._drawViewMarksOT('otViewCanvasFrente', 'otViewImgFrente', 'tractor-frente', marcas);
          this._drawViewMarksOT('otViewCanvasTrasera', 'otViewImgTrasera', 'tractor-trasera', marcas);
          this._drawViewMarksOT('otViewCanvasLatIzq', 'otViewImgLatIzq', 'tractor-lateral-izq', marcas);
          this._drawViewMarksOT('otViewCanvasLatDer', 'otViewImgLatDer', 'tractor-lateral-der', marcas);
        }
      }, 100);

      // Atajo de teclado ← → para navegar entre vistas también en modo view.
      if (!this._otViewKeydownHandler) {
        this._otViewKeydownHandler = (e) => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          const t = e.target;
          if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
          const card = document.querySelector('.ot-vh-card');
          if (!card || card.offsetParent === null) return;
          this._navOTViewSlide(e.key === 'ArrowRight' ? 1 : -1);
        };
        document.addEventListener('keydown', this._otViewKeydownHandler);
      }
    } else {
      setTimeout(() => {
        this._initAnnotationCanvasOT('otCanvasFrente', 'otImgFrente', 'tractor-frente');
        this._initAnnotationCanvasOT('otCanvasTrasera', 'otImgTrasera', 'tractor-trasera');
        this._initAnnotationCanvasOT('otCanvasLatIzq', 'otImgLatIzq', 'tractor-lateral-izq');
        this._initAnnotationCanvasOT('otCanvasLatDer', 'otImgLatDer', 'tractor-lateral-der');
        this._updateOTHeader();
        // Inicializa el hint con el modo default (move) — fuente única de
        // verdad: el HTML del <p> está vacío y todo el texto lo gobierna JS.
        this._updateModeHint(this._markMode?.[this._activeOTSlide] || 'move');
      }, 100);

      // Atajo de teclado ← → para navegar entre vistas, solo cuando el tab
      // está visible y el foco NO está en un input/textarea (para no robar
      // navegación de cursor en campos de texto como Observaciones).
      if (!this._otKeydownHandler) {
        this._otKeydownHandler = (e) => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          const t = e.target;
          if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
          // Solo si la card de inspección está visible.
          const card = document.querySelector('.ot-vh-card');
          if (!card || card.offsetParent === null) return;
          this._navOTSlide(e.key === 'ArrowRight' ? 1 : -1);
        };
        document.addEventListener('keydown', this._otKeydownHandler);
      }
    }
  },

  // Actualiza el header (título de vista + count) y el stats global.
  _updateOTHeader() {
    if (this.data.isReadOnly) return;
    const titleMap = {
      'tractor-frente': 'Frontal',
      'tractor-trasera': 'Trasera',
      'tractor-lateral-izq': 'Lateral Izquierdo',
      'tractor-lateral-der': 'Lateral Derecho'
    };
    const active = this._activeOTSlide || 'tractor-frente';
    const all = this._marcasVisuales || this._editData?.marcas_visuales || [];
    const total = all.length;

    const tEl = document.getElementById('otViewTitle');
    const tabBadge = document.getElementById('otTabInspBadge');
    if (tEl) tEl.textContent = titleMap[active] || active;
    // Badge en el tab "Inspección Visual" con el total de marcas. Se oculta
    // (string vacío) si el total es 0 para no ensuciar el tab cuando no hay nada.
    if (tabBadge) tabBadge.textContent = total > 0 ? ` (${total})` : '';

    // Refresca también el zoom label del header (operate sobre vista activa).
    const zoomLevel = (this._zoomLevels && this._zoomLevels[active]) || 1;
    const zEl = document.getElementById('otZoomLabelActive');
    if (zEl) zEl.textContent = `${Math.round(zoomLevel * 100)}%`;
  },

  // Navegar entre vistas con las flechas (-1 = anterior, +1 = siguiente).
  // Wrap-around: después de la última vuelve a la primera.
  _navOTSlide(direction) {
    const order = this._otSlidesOrder || ['tractor-frente', 'tractor-trasera', 'tractor-lateral-izq', 'tractor-lateral-der'];
    const current = this._activeOTSlide || order[0];
    const idx = order.indexOf(current);
    const nextIdx = (idx + direction + order.length) % order.length;
    this._switchOTSlide(order[nextIdx]);
  },

  // Zoom sobre el slide activo (atajo para los botones del header).
  _zoomOTActive(direction) {
    if (!this._activeOTSlide) return;
    this._zoomOT(this._activeOTSlide, direction);
    this._updateOTHeader();
  },

  _initAnnotationCanvasOT(canvasId, imgId, imgKey) {
    const canvas = document.getElementById(canvasId);
    const img = document.getElementById(imgId);
    if (!canvas || !img) return;

    const setup = () => {
      canvas.width = img.naturalWidth || img.offsetWidth;
      canvas.height = img.naturalHeight || img.offsetHeight;
      this._drawMarksOT(canvasId, imgKey);
    };

    if (img.complete) {
      setup();
    } else {
      img.onload = setup;
    }

    // Crear canvas oculto para detectar pixeles de la imagen
    const _hitCanvas = document.createElement('canvas');
    const _hitCtx = _hitCanvas.getContext('2d');
    const _loadHitCanvas = () => {
      _hitCanvas.width = img.naturalWidth;
      _hitCanvas.height = img.naturalHeight;
      _hitCtx.drawImage(img, 0, 0);
    };
    if (img.complete) _loadHitCanvas();
    else img.addEventListener('load', _loadHitCanvas);

    // Estado de drag para "arrastrar para dimensionar" (drag-to-size).
    // Si el usuario solo hace pointerdown+pointerup sin mover, cae a default 2.5%.
    let dragState = null;
    let clickedExisting = null;

    const getCoords = (e) => {
      const rect = canvas.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      return { x, y };
    };

    const findMarkAt = (x, y) => {
      // Hit radius dinámico: depende del radio de cada marca para que las
      // pequeñas también sean clickeables. Mínimo 2% del canvas.
      return this._marcasVisuales.find(m => {
        if (m.img !== imgKey) return false;
        const r = Math.max(2, (typeof m.radius_pct === 'number' && m.radius_pct > 0) ? m.radius_pct : 2.5);
        return Math.abs(m.x - x) < r && Math.abs(m.y - y) < r;
      });
    };

    const isPixelOnTractor = (x, y) => {
      const px = Math.round((x / 100) * _hitCanvas.width);
      const py = Math.round((y / 100) * _hitCanvas.height);
      try {
        const pixel = _hitCtx.getImageData(px, py, 1, 1).data;
        return !(pixel[0] > 240 && pixel[1] > 240 && pixel[2] > 240);
      } catch (err) { /* CORS u otra → asumimos OK */ return true; }
    };

    canvas.addEventListener('pointerdown', (e) => {
      const { x, y } = getCoords(e);
      const mode = this._markMode?.[imgKey] || 'add';
      clickedExisting = null;
      dragState = null;

      if (mode === 'delete') {
        const marcaExistente = findMarkAt(x, y);
        if (!marcaExistente) return;
        const idx = this._marcasVisuales.indexOf(marcaExistente);
        if (marcaExistente.foto_url) {
          if (!this._fotosEliminar) this._fotosEliminar = [];
          this._fotosEliminar.push(marcaExistente.foto_url);
        }
        if (this._fotosPendientes) {
          this._fotosPendientes = this._fotosPendientes.filter(m => m !== marcaExistente);
        }
        this._marcasVisuales.splice(idx, 1);
        this._drawMarksOT(canvasId, imgKey);
        this._updateOTHeader();
        this._showUnsaved();
        return;
      }

      // Tap sobre marca existente. Comportamiento depende del modo:
      //  - move: abrir el visor/captura de foto (consulta).
      //  - add: NO hacer nada (modo enfocado en crear marcas nuevas). Toast
      //    sugiere cambiar a Mover si quería ver la foto.
      const marcaExistente = findMarkAt(x, y);
      if (marcaExistente) {
        if (mode === 'move') {
          clickedExisting = marcaExistente;
          return;
        }
        if (mode === 'add') {
          toast.info('Cambia a 🤚 Mover para ver fotos de un punto existente');
          return;
        }
      }

      // De aquí en adelante: crear marca nueva (solo aplica en modo "add").
      // En modo "move" sin marca debajo, no hacemos nada → el browser
      // interpreta el touch como pan/scroll del contenedor.
      if (mode !== 'add') return;

      // Verificar que el centro caiga sobre la imagen del tractor (no fondo).
      if (!isPixelOnTractor(x, y)) {
        toast.warning('Solo puede marcar sobre la imagen del tractor');
        return;
      }

      // Inicia drag: el centro queda en el pointerdown, el radio se mide en pointerup.
      dragState = { startX: x, startY: y, currentRadiusPct: 0 };
      try { canvas.setPointerCapture(e.pointerId); } catch (_) { /* noop */ }
    });

    canvas.addEventListener('pointermove', (e) => {
      if (!dragState) return;
      const { x, y } = getCoords(e);
      const dx = x - dragState.startX;
      const dy = y - dragState.startY;
      const radiusPct = Math.min(25, Math.hypot(dx, dy));
      dragState.currentRadiusPct = radiusPct;
      this._drawMarksOT(canvasId, imgKey, {
        img: imgKey,
        x: dragState.startX,
        y: dragState.startY,
        radius_pct: Math.max(radiusPct, 0.5)
      });
    });

    canvas.addEventListener('pointerup', (e) => {
      try { canvas.releasePointerCapture(e.pointerId); } catch (_) { /* noop */ }

      // Si el pointerdown cayó sobre una marca existente, este pointerup
      // se interpreta como click: abrir visor o solicitar foto.
      if (clickedExisting) {
        const m = clickedExisting;
        clickedExisting = null;
        if (m.foto_url || m._foto_preview) {
          this._verFotoDanio(m, canvasId, imgKey);
        } else {
          this._solicitarFotoDanio(m, canvasId, imgKey);
        }
        return;
      }

      if (!dragState) return;
      const { startX, startY, currentRadiusPct } = dragState;
      dragState = null;

      // Si el drag fue demasiado chico (menos de ~1%), cae al tamaño default
      // — preserva el "solo click crea marca" para usuarios que no descubren el drag.
      const DEFAULT_RADIUS_PCT = 2.5;
      const MIN_USER_RADIUS_PCT = 1.0;
      const radius_pct = currentRadiusPct < MIN_USER_RADIUS_PCT
        ? DEFAULT_RADIUS_PCT
        : Math.round(currentRadiusPct * 10) / 10;

      const now = new Date();
      const fechaMarca = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}:${String(now.getSeconds()).padStart(2,'0')}`;
      const marca = {
        img: imgKey,
        x: Math.round(startX * 10) / 10,
        y: Math.round(startY * 10) / 10,
        radius_pct,
        foto_url: null,
        fecha_marca: fechaMarca
      };
      this._marcasVisuales.push(marca);
      this._drawMarksOT(canvasId, imgKey);
      this._updateOTHeader();
      this._showUnsaved();
      this._solicitarFotoDanio(marca, canvasId, imgKey);
    });

    canvas.addEventListener('pointercancel', () => {
      dragState = null;
      clickedExisting = null;
      this._drawMarksOT(canvasId, imgKey);
    });
  },

  _drawMarksOT(canvasId, imgKey, previewMark = null) {
    const canvas = document.getElementById(canvasId);
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const marks = (this._marcasVisuales || []).filter(m => m.img === imgKey);
    marks.forEach((mark, i) => {
      const px = (mark.x / 100) * canvas.width;
      const py = (mark.y / 100) * canvas.height;
      // Marcas nuevas guardan radius_pct (% del ancho del canvas).
      // Marcas viejas sin el campo → fallback al tamaño anterior (~2.5%).
      const radiusPct = (typeof mark.radius_pct === 'number' && mark.radius_pct > 0) ? mark.radius_pct : 2.5;
      const radius = Math.max(6, (radiusPct / 100) * canvas.width);

      // Círculo rojo semi-transparente: deja ver la parte del tractor
      // que está marcada, pero sigue siendo claramente visible.
      ctx.beginPath();
      ctx.arc(px, py, radius, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(220, 53, 69, 0.65)';
      ctx.fill();
      ctx.strokeStyle = '#dc3545';
      ctx.lineWidth = 2.5;
      ctx.stroke();

      // Número dentro del círculo (solo si cabe sin verse mal)
      if (radius >= 10) {
        ctx.fillStyle = '#fff';
        ctx.font = `bold ${Math.max(10, radius * 0.9)}px sans-serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(String(i + 1), px, py + 1);
      }
    });

    // Preview en vivo mientras el usuario arrastra para crear una marca nueva.
    if (previewMark && previewMark.img === imgKey) {
      const px = (previewMark.x / 100) * canvas.width;
      const py = (previewMark.y / 100) * canvas.height;
      const radius = Math.max(4, (previewMark.radius_pct / 100) * canvas.width);
      ctx.beginPath();
      ctx.arc(px, py, radius, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(220, 53, 69, 0.4)';
      ctx.fill();
      ctx.strokeStyle = '#dc3545';
      ctx.lineWidth = 2;
      ctx.setLineDash([4, 4]);
      ctx.stroke();
      ctx.setLineDash([]);
    }
  },

  _drawViewMarksOT(canvasId, imgId, imgKey, marcas) {
    const canvas = document.getElementById(canvasId);
    const img = document.getElementById(imgId);
    if (!canvas || !img) return;

    const filtered = marcas.filter(m => m.img === imgKey);
    const hasFotos = filtered.some(m => m.foto_url);

    const draw = () => {
      canvas.width = img.naturalWidth || img.offsetWidth;
      canvas.height = img.naturalHeight || img.offsetHeight;
      const ctx = canvas.getContext('2d');
      filtered.forEach((mark, i) => {
        const px = (mark.x / 100) * canvas.width;
        const py = (mark.y / 100) * canvas.height;
        const radiusPct = (typeof mark.radius_pct === 'number' && mark.radius_pct > 0) ? mark.radius_pct : 2.5;
        const radius = Math.max(6, (radiusPct / 100) * canvas.width);

        // Círculo rojo semi-transparente: deja ver la parte del tractor
        // que está marcada, pero sigue siendo claramente visible.
        ctx.beginPath();
        ctx.arc(px, py, radius, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(220, 53, 69, 0.65)';
        ctx.fill();
        ctx.strokeStyle = '#dc3545';
        ctx.lineWidth = 2.5;
        ctx.stroke();

        // Número dentro del círculo (solo si cabe sin verse mal)
        if (radius >= 10) {
          ctx.fillStyle = '#fff';
          ctx.font = `bold ${Math.max(10, radius * 0.9)}px sans-serif`;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(String(i + 1), px, py + 1);
        }
      });
    };

    if (img.complete) draw(); else img.onload = draw;

    // Click en marcas con foto para verlas
    if (hasFotos) {
      canvas.style.pointerEvents = 'auto';
      canvas.style.cursor = 'pointer';
      canvas.addEventListener('click', (e) => {
        const rect = canvas.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        const hitRadius = 4;
        const hit = filtered.find(m => m.foto_url && Math.abs(m.x - x) < hitRadius && Math.abs(m.y - y) < hitRadius);
        if (hit) this._verFotoDanio(hit);
      });
    }
  },

  _setMarkModeOT(imgKey, mode) {
    if (!imgKey) return;
    if (!this._markMode) this._markMode = {};
    this._markMode[imgKey] = mode;

    // Si el modo se cambia desde la vista que NO está activa (caso raro pero
    // posible), igual actualizamos su canvas/cursor. El toggle visible solo
    // refleja el modo de la vista activa — `_syncOTModeButtons` se encarga.
    if (imgKey === this._activeOTSlide) {
      this._syncOTModeButtons();
      this._updateModeHint(mode);
    }

    const idSuffix = { 'tractor-frente': 'Frente', 'tractor-trasera': 'Trasera', 'tractor-lateral-izq': 'LatIzq', 'tractor-lateral-der': 'LatDer' }[imgKey];
    if (!idSuffix) return;

    const wrap = document.getElementById(`otWrap${idSuffix}`);
    if (wrap) {
      if (mode === 'delete') wrap.style.cursor = 'pointer';
      else if (mode === 'move') wrap.style.cursor = 'grab';
      else wrap.style.cursor = 'crosshair';
    }

    // Modo "move": touch-action: auto deja al browser pan/scroll cuando
    // detecta movimiento (cancela nuestros pointer events con pointercancel).
    // PERO mantenemos pointer-events: auto para que un tap puntual (sin
    // movimiento) sí llegue al canvas y nos permita abrir la foto al
    // clickear sobre una marca existente. Comportamiento de Google Maps:
    // tap sobre pin abre detalle, arrastrar mueve el mapa.
    //
    // Modo add/delete: touch-action: none bloquea el pan del browser para
    // que el drag-to-size y el delete-click funcionen sin interferencia.
    const canvas = document.getElementById(`otCanvas${idSuffix}`);
    if (canvas) {
      if (mode === 'move') {
        canvas.style.touchAction = 'auto';
        canvas.style.pointerEvents = 'auto';
      } else {
        canvas.style.touchAction = 'none';
        canvas.style.pointerEvents = 'auto';
      }
    }
  },

  _solicitarFotoDanio(marca, canvasId, imgKey) {
    // Inicializar almacén temporal de fotos pendientes
    if (!this._fotosPendientes) this._fotosPendientes = [];

    // Crear modal para capturar foto
    const overlay = document.createElement('div');
    overlay.id = 'modalFotoDanio';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:center;justify-content:center;';
    const ubicacionMap = {
      'tractor-frente': 'Frontal',
      'tractor-trasera': 'Trasera',
      'tractor-lateral-izq': 'Lateral Izquierdo',
      'tractor-lateral-der': 'Lateral Derecho'
    };
    const numPunto = (this._marcasVisuales || []).filter(m => m.img === imgKey).length;
    const ubicacion = ubicacionMap[imgKey] || imgKey;

    overlay.innerHTML = `
      <div style="background:#fff;border-radius:16px;width:92%;max-width:800px;box-shadow:0 16px 48px rgba(0,0,0,0.4);overflow:hidden;max-height:90vh;overflow-y:auto;">
        <!-- Header -->
        <div style="background:var(--primary);padding:1.25rem 1.25rem 0.75rem;display:flex;justify-content:space-between;align-items:flex-start;">
          <div>
            <h3 style="margin:0 0 0.15rem;font-size:1rem;font-weight:700;color:#fff;">Punto #${numPunto} — ${ubicacion}</h3>
            <p style="margin:0;font-size:0.8rem;color:rgba(255,255,255,0.7);" id="fotoDanioSubtitulo">Capture la evidencia del daño</p>
          </div>
          <button type="button" id="fotoDanioCerrar" style="background:none;border:none;color:rgba(255,255,255,0.6);font-size:1.3rem;cursor:pointer;padding:0;line-height:1;">&times;</button>
        </div>
        <!-- Preview / Captura / Cámara in-page -->
        <div style="padding:1rem 1.25rem;">
          <div id="fotoDanioPreview" style="display:none;margin-bottom:0.75rem;background:#f8f9fa;border-radius:10px;padding:0.5rem;text-align:center;">
            <img id="fotoDanioImg" style="width:100%;max-height:220px;object-fit:contain;border-radius:8px;" />
          </div>
          <!-- Vista de selección: dos botones -->
          <div id="fotoDanioCaptura" style="margin-bottom:0.75rem;">
            <div style="display:flex;gap:0.5rem;">
              <button type="button" id="fotoDanioBtnCamera" style="flex:1;display:flex;flex-direction:column;align-items:center;gap:0.35rem;padding:1.5rem 0.5rem;border:2px dashed var(--primary-light);border-radius:10px;cursor:pointer;background:rgba(37,99,235,0.04);">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="var(--primary)" stroke-width="1.5"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>
                <span style="font-size:0.75rem;font-weight:600;color:var(--primary);">Tomar foto</span>
              </button>
              <label style="flex:1;display:flex;flex-direction:column;align-items:center;gap:0.35rem;padding:1.5rem 0.5rem;border:2px dashed #dee2e6;border-radius:10px;cursor:pointer;background:#f8f9fa;">
                <input type="file" accept="image/*" id="fotoDanioInputGaleria" style="display:none;" />
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6c757d" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                <span style="font-size:0.75rem;font-weight:600;color:#6c757d;">Galería</span>
              </label>
            </div>
          </div>
          <!-- Vista de cámara in-page: video stream + controles. Evita la app
               nativa de cámara (que en mobile puede causar reload del browser
               por presión de memoria — eviction de la pestaña). -->
          <div id="fotoDanioCameraView" style="display:none;margin-bottom:0.75rem;background:#000;border-radius:10px;overflow:hidden;">
            <video id="fotoDanioVideo" autoplay playsinline muted style="width:100%;max-height:60vh;display:block;background:#000;object-fit:cover;"></video>
            <div style="display:flex;gap:0.5rem;padding:0.6rem;background:#111;">
              <button type="button" id="fotoDanioCameraCancelar" style="flex:1;padding:0.6rem;border:none;border-radius:8px;background:#444;color:#fff;font-size:0.85rem;font-weight:600;cursor:pointer;">Cancelar</button>
              <button type="button" id="fotoDanioCameraSwitch" title="Cambiar cámara" style="width:48px;padding:0.6rem;border:none;border-radius:8px;background:#444;color:#fff;font-size:1rem;cursor:pointer;">⇄</button>
              <button type="button" id="fotoDanioCameraCapturar" style="flex:2;padding:0.6rem;border:none;border-radius:8px;background:var(--primary);color:#fff;font-size:0.9rem;font-weight:700;cursor:pointer;">Capturar</button>
            </div>
          </div>
        </div>
        <!-- Observación -->
        <div style="padding:0 1.25rem;">
          <div id="fotoDanioObsToggle" style="cursor:pointer;padding:0.5rem 0;display:flex;align-items:center;gap:0.35rem;color:var(--primary);font-size:0.8rem;">
            <span id="fotoDanioObsIcon">+</span> Agregar observación (opcional)
          </div>
          <div id="fotoDanioObsWrap" style="display:none;margin-bottom:0.5rem;">
            <textarea id="fotoDanioObs" rows="3" placeholder="Describa el daño observado..." style="width:100%;border:1px solid #dee2e6;border-radius:8px;background:#f8f9fa;color:#333;padding:0.6rem;font-size:0.85rem;resize:none;box-sizing:border-box;"></textarea>
          </div>
        </div>
        <!-- Acciones -->
        <div style="padding:0.75rem 1.25rem 1.25rem;display:flex;gap:0.75rem;">
          <button type="button" id="fotoDanioCancelar" style="flex:1;padding:0.7rem;border:1px solid #dee2e6;border-radius:10px;background:#fff;color:#333;font-size:0.9rem;font-weight:600;cursor:pointer;">Cancelar</button>
          <button type="button" id="fotoDanioGuardar" style="flex:1;padding:0.7rem;border:none;border-radius:10px;background:#dee2e6;color:#adb5bd;font-size:0.9rem;font-weight:600;cursor:not-allowed;display:flex;align-items:center;justify-content:center;gap:0.35rem;" disabled>Guardar <span style="font-size:1rem;">&#10003;</span></button>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);

    let archivoSeleccionado = null;
    let previewDataUrl = null;
    let activeStream = null;
    let cameraFacingMode = 'environment';

    // Procesa un archivo (de cámara in-page o galería) y muestra el preview.
    const handleFile = async (file) => {
      // Comprimir antes de guardar para que la galería no mande archivos
      // crudos que rebasen el límite de 5 MB del backend (LIMIT_FILE_SIZE).
      // La cámara in-page ya entrega archivos chicos vía constraints+JPEG 0.85,
      // así que comprimir aquí es redundante pero inofensivo (~50 ms extra).
      const compressed = await compressImage(file);
      archivoSeleccionado = compressed;
      const reader = new FileReader();
      reader.onload = (ev) => {
        previewDataUrl = ev.target.result;
        document.getElementById('fotoDanioImg').src = previewDataUrl;
        document.getElementById('fotoDanioPreview').style.display = 'block';
        document.getElementById('fotoDanioCaptura').style.display = 'none';
        document.getElementById('fotoDanioCameraView').style.display = 'none';
        document.getElementById('fotoDanioSubtitulo').textContent = '¿Confirmar esta foto?';
        const btnGuardar = document.getElementById('fotoDanioGuardar');
        btnGuardar.disabled = false;
        btnGuardar.style.background = 'var(--primary)';
        btnGuardar.style.color = '#fff';
        btnGuardar.style.cursor = 'pointer';
      };
      reader.readAsDataURL(compressed);
    };

    // Detiene cualquier MediaStream activo (libera la cámara).
    const stopCameraStream = () => {
      if (activeStream) {
        activeStream.getTracks().forEach(t => t.stop());
        activeStream = null;
      }
      const video = document.getElementById('fotoDanioVideo');
      if (video) video.srcObject = null;
    };

    // Inicia la cámara in-page. Si falla (permiso denegado, sin cámara, etc.)
    // muestra error y deja al usuario usar "Galería".
    const startCamera = async () => {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        toast.error('Tu navegador no soporta cámara in-page. Usa "Galería".');
        return;
      }
      try {
        const constraints = {
          video: { facingMode: cameraFacingMode, width: { ideal: 1280 }, height: { ideal: 720 } },
          audio: false
        };
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        activeStream = stream;
        document.getElementById('fotoDanioCaptura').style.display = 'none';
        document.getElementById('fotoDanioCameraView').style.display = 'block';
        const video = document.getElementById('fotoDanioVideo');
        video.srcObject = stream;
      } catch (err) {
        console.error('Error al abrir cámara:', err);
        const msg = err.name === 'NotAllowedError'
          ? 'Permiso de cámara denegado. Revisa los permisos del navegador o usa "Galería".'
          : 'No se pudo abrir la cámara. Usa "Galería".';
        toast.error(msg);
      }
    };

    const cerrarCamara = () => {
      stopCameraStream();
      document.getElementById('fotoDanioCameraView').style.display = 'none';
      document.getElementById('fotoDanioCaptura').style.display = '';
    };

    const cambiarCamara = async () => {
      cameraFacingMode = cameraFacingMode === 'environment' ? 'user' : 'environment';
      stopCameraStream();
      await startCamera();
    };

    const capturarFoto = () => {
      const video = document.getElementById('fotoDanioVideo');
      if (!video || !video.videoWidth) {
        toast.warning('La cámara todavía no está lista, espera un momento.');
        return;
      }
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0);
      canvas.toBlob((blob) => {
        if (!blob) {
          toast.error('No se pudo capturar la imagen.');
          return;
        }
        const file = new File([blob], `foto-danio-${Date.now()}.jpg`, { type: 'image/jpeg' });
        stopCameraStream();
        handleFile(file);
      }, 'image/jpeg', 0.85);
    };

    document.getElementById('fotoDanioBtnCamera').addEventListener('click', startCamera);
    document.getElementById('fotoDanioCameraCancelar').addEventListener('click', cerrarCamara);
    document.getElementById('fotoDanioCameraSwitch').addEventListener('click', cambiarCamara);
    document.getElementById('fotoDanioCameraCapturar').addEventListener('click', capturarFoto);
    document.getElementById('fotoDanioInputGaleria').addEventListener('change', (e) => {
      const file = e.target.files[0];
      if (file) handleFile(file);
    });

    // Toggle observación
    document.getElementById('fotoDanioObsToggle').addEventListener('click', () => {
      const wrap = document.getElementById('fotoDanioObsWrap');
      const icon = document.getElementById('fotoDanioObsIcon');
      const toggle = document.getElementById('fotoDanioObsToggle');
      if (wrap.style.display === 'none') {
        wrap.style.display = 'block';
        icon.textContent = '—';
        toggle.childNodes[toggle.childNodes.length - 1].textContent = ' Observación';
      } else {
        wrap.style.display = 'none';
        icon.textContent = '+';
        toggle.childNodes[toggle.childNodes.length - 1].textContent = ' Agregar observación (opcional)';
      }
    });

    // Cancelar / cerrar — eliminar marca si no tiene foto, y liberar cámara
    // si quedó algún stream activo (importante: si no se libera, el LED queda
    // prendido y la cámara sigue ocupada hasta cerrar la pestaña).
    const cancelar = () => {
      stopCameraStream();
      const idx = this._marcasVisuales.indexOf(marca);
      if (idx >= 0 && !marca.foto_url && !marca._foto_pendiente) {
        this._marcasVisuales.splice(idx, 1);
        this._drawMarksOT(canvasId, imgKey);
        if (typeof this._updateOTHeader === 'function') this._updateOTHeader();
      }
      overlay.remove();
    };

    document.getElementById('fotoDanioCancelar').addEventListener('click', cancelar);
    document.getElementById('fotoDanioCerrar').addEventListener('click', cancelar);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) cancelar(); });

    document.getElementById('fotoDanioGuardar').addEventListener('click', () => {
      if (!archivoSeleccionado) return;
      stopCameraStream();
      // Guardar en memoria
      marca._foto_pendiente = archivoSeleccionado;
      marca._foto_preview = previewDataUrl;
      marca.observacion = (document.getElementById('fotoDanioObs')?.value || '').trim() || null;
      this._fotosPendientes.push(marca);
      this._drawMarksOT(canvasId, imgKey);
      this._showUnsaved();
      toast.success('Foto lista (se subirá al guardar cambios)');
      overlay.remove();
    });
  },

  _verFotoDanio(marca, canvasId, imgKey) {
    const ubicacionMap = {
      'tractor-frente': 'Frontal',
      'tractor-trasera': 'Trasera',
      'tractor-lateral-izq': 'Lateral Izquierdo',
      'tractor-lateral-der': 'Lateral Derecho'
    };
    const img = marca.img || imgKey;
    const ubicacion = ubicacionMap[img] || img;
    const fotoSrc = marca.foto_url || marca._foto_preview || '';
    const marcasDeVista = (this._marcasVisuales || this._editData?.marcas_visuales || []).filter(m => m.img === img);
    const numPunto = marcasDeVista.indexOf(marca) + 1;

    // Formatear fecha de marca
    let fechaTexto = '';
    if (marca.fecha_marca) {
      const parts = marca.fecha_marca.split(' ');
      const fParts = parts[0].split('-');
      fechaTexto = fParts.length === 3 ? `${fParts[2]}/${fParts[1]}/${fParts[0]}` : parts[0];
      if (parts[1]) fechaTexto += ' · ' + parts[1].substring(0, 5);
    }

    const overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:center;justify-content:center;';
    overlay.innerHTML = `
      <div style="background:#fff;border-radius:16px;width:95%;max-width:800px;box-shadow:0 16px 48px rgba(0,0,0,0.35);overflow:hidden;max-height:90vh;overflow-y:auto;">
        <!-- Header -->
        <div style="background:var(--primary);padding:1rem 1.25rem;display:flex;justify-content:space-between;align-items:flex-start;">
          <div>
            <h3 style="margin:0 0 0.15rem;font-size:1rem;font-weight:700;color:#fff;">Punto #${numPunto}</h3>
            <p style="margin:0;font-size:0.75rem;color:rgba(255,255,255,0.7);">${fechaTexto}</p>
          </div>
          <button type="button" id="verDanioCerrar" style="background:none;border:none;color:rgba(255,255,255,0.6);font-size:1.4rem;cursor:pointer;padding:0;line-height:1;">&times;</button>
        </div>
        <!-- Foto -->
        <div style="background:#f1f3f5;padding:1rem;text-align:center;position:relative;">
          ${fotoSrc
            ? `<img src="${fotoSrc}" style="width:100%;max-height:60vh;object-fit:contain;border-radius:8px;" />`
            : `<div style="padding:2rem;color:#adb5bd;"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg><p style="margin:0.5rem 0 0;font-size:0.8rem;">Sin foto</p></div>`
          }
          <div style="position:absolute;bottom:1.25rem;right:1.25rem;background:rgba(0,0,0,0.5);color:#fff;font-size:0.7rem;padding:0.15rem 0.5rem;border-radius:4px;">1/1</div>
        </div>
        <!-- Detalles -->
        <div style="padding:1rem 1.25rem;">
          <div style="margin-bottom:0.75rem;">
            <div style="font-size:0.65rem;text-transform:uppercase;letter-spacing:0.5px;color:#6c757d;margin-bottom:0.15rem;">Vista</div>
            <div style="font-size:0.85rem;font-weight:600;color:#333;">${ubicacion}</div>
          </div>
          <div style="margin-bottom:0.5rem;">
            <div style="font-size:0.65rem;text-transform:uppercase;letter-spacing:0.5px;color:#6c757d;margin-bottom:0.15rem;">Observaciones</div>
            ${marca.observacion
              ? `<p style="margin:0;font-size:0.85rem;color:#333;background:#f8f9fa;padding:0.5rem 0.75rem;border-radius:6px;border-left:3px solid var(--primary);">${marca.observacion}</p>`
              : `<p style="margin:0;font-size:0.8rem;color:#adb5bd;font-style:italic;">Sin observaciones registradas.</p>`
            }
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);

    // Cerrar
    document.getElementById('verDanioCerrar').addEventListener('click', () => overlay.remove());
    overlay.addEventListener('click', (e) => { if (e.target === overlay) overlay.remove(); });

  },

  _zoomOT(imgKey, direction, mode) {
    if (!this._zoomLevels) this._zoomLevels = {};
    const isView = mode === 'view';

    let level = this._zoomLevels[imgKey] || 1;
    level = Math.max(1, Math.min(3, +(level + direction * 0.25).toFixed(2)));
    this._zoomLevels[imgKey] = level;

    const idMap = {
      'tractor-frente':      { img: 'otImgFrente',   viewImg: 'otViewImgFrente',   scroll: 'otScrollFrente',   viewScroll: 'otViewScrollFrente',   label: 'otZoomLabelFrente',   viewLabel: 'otViewZoomLabelFrente' },
      'tractor-trasera':     { img: 'otImgTrasera',  viewImg: 'otViewImgTrasera',  scroll: 'otScrollTrasera',  viewScroll: 'otViewScrollTrasera',  label: 'otZoomLabelTrasera',  viewLabel: 'otViewZoomLabelTrasera' },
      'tractor-lateral-izq': { img: 'otImgLatIzq',   viewImg: 'otViewImgLatIzq',   scroll: 'otScrollLatIzq',   viewScroll: 'otViewScrollLatIzq',   label: 'otZoomLabelLatIzq',   viewLabel: 'otViewZoomLabelLatIzq' },
      'tractor-lateral-der': { img: 'otImgLatDer',    viewImg: 'otViewImgLatDer',    scroll: 'otScrollLatDer',    viewScroll: 'otViewScrollLatDer',    label: 'otZoomLabelLatDer',    viewLabel: 'otViewZoomLabelLatDer' }
    };
    const ids = idMap[imgKey];
    if (!ids) return;

    const img = document.getElementById(isView ? ids.viewImg : ids.img);
    if (img) {
      if (level === 1) {
        img.style.width = '100%';
      } else {
        const nw = img.naturalWidth || img.offsetWidth;
        img.style.width = `${nw * level}px`;
      }
    }

    const scroll = document.getElementById(isView ? ids.viewScroll : ids.scroll);
    if (scroll) scroll.style.overflow = level > 1 ? 'auto' : 'hidden';

    const label = document.getElementById(isView ? ids.viewLabel : ids.label);
    if (label) label.textContent = `${Math.round(level * 100)}%`;
  },

  _switchOTSlide(imgKey) {
    const slides = ['tractor-frente', 'tractor-trasera', 'tractor-lateral-izq', 'tractor-lateral-der'];
    slides.forEach(key => {
      const slide = document.getElementById(`otEditSlide-${key}`);
      if (slide) slide.style.display = key === imgKey ? 'block' : 'none';
    });
    this._activeOTSlide = imgKey;
    // Refresca header (título + count), stats globales y zoom label de la
    // vista activa. También sincroniza los botones del toggle con el modo
    // guardado por vista (cada vista tiene su propio _markMode).
    this._updateOTHeader();
    this._syncOTModeButtons();
    const modeActual = (this._markMode && this._markMode[imgKey]) || 'move';
    this._updateModeHint(modeActual);
  },

  // Actualiza el hint contextual debajo del toolbar según el modo activo.
  // El hint explica qué hace cada modo para que el usuario nuevo entienda
  // que en "Marcar" puede arrastrar para dimensionar (descubrimiento difícil
  // sin pista visual).
  _updateModeHint(mode) {
    const el = document.getElementById('otModeHint');
    if (!el) return;
    // Limpia clases viejas y agrega la del modo nuevo
    el.classList.remove('ot-mode-hint-move', 'ot-mode-hint-add', 'ot-mode-hint-delete');
    el.classList.add(`ot-mode-hint-${mode || 'move'}`);
    const hints = {
      move:   '💡 <strong>Mover:</strong> Arrastra la imagen para moverte · Toca un punto marcado para ver su foto',
      add:    '💡 <strong>Marcar:</strong> Toca un espacio para crear un punto · <em>Arrastra</em> para ajustar el tamaño',
      delete: '💡 <strong>Eliminar:</strong> toca un daño para borrarlo'
    };
    el.innerHTML = hints[mode] || hints.move;
  },

  // Sincroniza el highlight de los botones del toggle (Mover/Marcar/Eliminar)
  // con el modo actual de la vista activa.
  _syncOTModeButtons() {
    if (this.data.isReadOnly) return;
    const active = this._activeOTSlide;
    if (!active) return;
    const mode = (this._markMode && this._markMode[active]) || 'move';
    const btnMov = document.getElementById('otModeMov');
    const btnAdd = document.getElementById('otModeAdd');
    const btnDel = document.getElementById('otModeDel');
    if (btnMov) btnMov.classList.toggle('ot-mode-active', mode === 'move');
    if (btnAdd) btnAdd.classList.toggle('ot-mode-active', mode === 'add');
    if (btnDel) btnDel.classList.toggle('ot-mode-active', mode === 'delete');
    // Las clases de color específicas (.ot-mode-move / .ot-mode-delete) se
    // mantienen estáticas en los botones; solo .ot-mode-active alterna.
  },

  _switchOTViewSlide(imgKey) {
    const slides = ['tractor-frente', 'tractor-trasera', 'tractor-lateral-izq', 'tractor-lateral-der'];
    slides.forEach(key => {
      const slide = document.getElementById(`otViewSlide-${key}`);
      if (slide) slide.style.display = key === imgKey ? 'block' : 'none';
    });
    this._activeOTViewSlide = imgKey;
    this._updateOTViewHeader();
  },

  // Actualiza el pill del modo view (título + progreso 2/4 vistas).
  _updateOTViewHeader() {
    if (!this.data.isReadOnly) return;
    const titleMap = {
      'tractor-frente': 'Frontal',
      'tractor-trasera': 'Trasera',
      'tractor-lateral-izq': 'Lateral Izquierdo',
      'tractor-lateral-der': 'Lateral Derecho'
    };
    const active = this._activeOTViewSlide || 'tractor-frente';

    const tEl = document.getElementById('otViewTitleRO');
    if (tEl) tEl.textContent = titleMap[active] || active;

    // Zoom label de la vista activa.
    const zoomLevel = (this._zoomLevels && this._zoomLevels[active]) || 1;
    const zEl = document.getElementById('otViewZoomLabelActive');
    if (zEl) zEl.textContent = `${Math.round(zoomLevel * 100)}%`;
  },

  // Navegar entre vistas con las flechas en modo view (wrap-around).
  _navOTViewSlide(direction) {
    const order = ['tractor-frente', 'tractor-trasera', 'tractor-lateral-izq', 'tractor-lateral-der'];
    const current = this._activeOTViewSlide || order[0];
    const idx = order.indexOf(current);
    const nextIdx = (idx + direction + order.length) % order.length;
    this._switchOTViewSlide(order[nextIdx]);
  },

  // Zoom sobre la vista activa en modo view.
  _zoomOTViewActive(direction) {
    const active = this._activeOTViewSlide || 'tractor-frente';
    this._zoomOT(active, direction, 'view');
    this._updateOTViewHeader();
  },

  _showUnsaved() {
    this._hasUnsaved = true;
    const indicator = document.getElementById('unsavedIndicator');
    if (indicator) indicator.style.display = 'block';
  },

  _clearUnsaved() {
    this._hasUnsaved = false;
    const indicator = document.getElementById('unsavedIndicator');
    if (indicator) indicator.style.display = 'none';
  },

  _showProgress(message) {
    let overlay = document.getElementById('progressOverlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'progressOverlay';
      overlay.style.cssText = 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.9); display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: 9999;';
      overlay.innerHTML = `
        <div class="spinner" style="margin-bottom: 1rem;"></div>
        <p id="progressMessage" style="font-size: 1rem; font-weight: 600; color: var(--gray-700);"></p>
      `;
      document.body.appendChild(overlay);
    }
    document.getElementById('progressMessage').textContent = message;
  },

  _hideProgress() {
    const overlay = document.getElementById('progressOverlay');
    if (overlay) overlay.remove();
  },

  _collectCurrentTabData() {
    if (!this._editData) return;

    // Recolectar textareas del tab visible antes de cambiar
    const obsPrev = document.getElementById('observacionesPrevias');
    const obsPost = document.getElementById('observacionesPosteriores');
    const obsVisual = document.getElementById('otObservacionesVisual');
    const obsFinales = document.getElementById('observacionesFinales');
    if (obsPrev) this._editData.observaciones_previas = obsPrev.value;
    if (obsPost) this._editData.observaciones_posteriores = obsPost.value;
    if (obsVisual) this._editData.observaciones_visual = obsVisual.value;
    if (obsFinales) this._editData.observaciones_posteriores = obsFinales.value;
  },

  async guardarCambios() {
    if (!this._editData) return;

    try {
      this._showProgress('Preparando datos...');
      // Recolectar textareas del tab actual
      this._collectCurrentTabData();

      // Convertir niveles de flat a nested para el backend
      const nivelesFluidos = { previo: [], posterior: [] };
      (this._editData.niveles || []).forEach(n => {
        const entry = { tipo_fluido: n.tipo_fluido, nivel_visual: n.nivel_visual };
        if (n.momento === 'previo') {
          nivelesFluidos.previo.push(entry);
        } else if (n.momento === 'posterior') {
          nivelesFluidos.posterior.push(entry);
        }
      });

      // Subir fotos pendientes a GCS antes de guardar (solo las marcas que aún existen)
      if (this._fotosPendientes && this._fotosPendientes.length > 0) {
        this._fotosPendientes = this._fotosPendientes.filter(m => this._editData.marcas_visuales.includes(m));
        if (this._fotosPendientes.length > 0) this._showProgress(`Subiendo ${this._fotosPendientes.length} foto(s)...`);
        let i = 0;
        for (const marca of this._fotosPendientes) {
          i++;
          if (marca._foto_pendiente && !marca.foto_url) {
            this._showProgress(`Subiendo foto ${i} de ${this._fotosPendientes.length}...`);
            const result = await produccionService.subirFotoInspeccion(marca._foto_pendiente, this.data.orden?.num_serie, 'ot');
            marca.foto_url = result.url;
          }
          delete marca._foto_pendiente;
          delete marca._foto_preview;
        }
        this._fotosPendientes = [];
      }

      // Eliminar fotos de GCS de marcas eliminadas
      if (this._fotosEliminar && this._fotosEliminar.length > 0) {
        for (const url of this._fotosEliminar) {
          await produccionService.eliminarArchivo(url).catch(err => console.error('Error al eliminar foto de GCS:', err));
        }
        this._fotosEliminar = [];
      }

      // Limpiar propiedades temporales de todas las marcas antes de enviar.
      // IMPORTANTE: preservar `radius_pct` (tamaño del círculo del drag-to-size).
      // Si una marca no tiene radius_pct (legacy o creada con click corto), no
      // lo enviamos y el render usa el default 2.5% al releer.
      const marcasLimpias = (this._editData.marcas_visuales || []).map(m => {
        const limpia = {
          img: m.img,
          x: m.x,
          y: m.y,
          foto_url: m.foto_url || null,
          fecha_marca: m.fecha_marca || null,
          observacion: m.observacion || null
        };
        if (typeof m.radius_pct === 'number' && m.radius_pct > 0) {
          limpia.radius_pct = m.radius_pct;
        }
        return limpia;
      });

      // Obtener fecha, reporte CRM y garantía del formulario de edición
      const fechaInput = document.querySelector('[name="fecha_edit"]');
      const reporteCrmInput = document.querySelector('[name="reporte_crm_edit"]');
      const garantiaInput = document.getElementById('garantiaCheckEdit');

      // Subir firmas dibujadas si las hay (se conservan las ya guardadas)
      const o = this.data.orden;
      let firmaTecnicoUrl = o.tecnico_servicio_firma_url || null;
      let firmaUsuarioUrl = o.usuario_firma_url || null;
      let firmaResponsableUrl = o.responsable_posventa_firma_url || null;

      if (this.signaturePadTecnico && !this.signaturePadTecnico.isEmpty()) {
        this._showProgress('Subiendo firma del técnico...');
        const blob = await this.toBlob(this.signaturePadTecnico);
        firmaTecnicoUrl = await recepcionService.subirFirma(blob, `OT-${o.id}_firma_tecnico.png`, o.num_serie, 'ot');
      }
      if (this.signaturePadUsuario && !this.signaturePadUsuario.isEmpty()) {
        this._showProgress('Subiendo firma del usuario...');
        const blob = await this.toBlob(this.signaturePadUsuario);
        firmaUsuarioUrl = await recepcionService.subirFirma(blob, `OT-${o.id}_firma_usuario.png`, o.num_serie, 'ot');
      }
      if (this.signaturePadResponsable && !this.signaturePadResponsable.isEmpty()) {
        this._showProgress('Subiendo firma del responsable...');
        const blob = await this.toBlob(this.signaturePadResponsable);
        firmaResponsableUrl = await recepcionService.subirFirma(blob, `OT-${o.id}_firma_responsable.png`, o.num_serie, 'ot');
      }

      this._showProgress('Guardando cambios...');
      await produccionService.guardarCambiosOT(this.data.orden.id, {
        fecha: fechaInput ? fechaInput.value : null,
        reporte_crm: reporteCrmInput ? reporteCrmInput.value || null : null,
        garantia: garantiaInput ? garantiaInput.checked : null,
        niveles_fluidos: nivelesFluidos,
        mantenimiento_items: this._editData.items_mantenimiento,
        diagnosticos: this._editData.diagnosticos,
        marcas_visuales: marcasLimpias,
        observaciones_previas: this._editData.observaciones_previas || null,
        observaciones_posteriores: this._editData.observaciones_posteriores || null,
        observaciones_visual: this._editData.observaciones_visual || null,
        tecnico_servicio_firma_url: firmaTecnicoUrl,
        usuario_firma_url: firmaUsuarioUrl,
        responsable_posventa_firma_url: firmaResponsableUrl
      });

      this._hideProgress();
      this._clearUnsaved();
      toast.success('Cambios guardados');

      // Recargar y restaurar tab actual
      const currentTab = this._currentTab || 'niveles';
      await this.cargarOrden(this.data.orden.id);
      this.showTab(currentTab);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al guardar cambios');
      console.error(error);
    }
  },

  getTipoBadge(tipo) {
    const badges = { 'mantenimiento': 'info', 'reparacion': 'warning', 'observacion': 'secondary' };
    return badges[tipo] || 'secondary';
  },

  formatTipo(tipo) {
    const tipos = { 'mantenimiento': 'Mantenimiento', 'reparacion': 'Reparación', 'observacion': 'Observación' };
    return tipos[tipo] || tipo;
  },

  getEstadoBadge(estado) {
    const badges = { 'abierta': 'info', 'completada': 'success' };
    return badges[estado] || 'secondary';
  },

  _setupClienteAutocomplete() {
    const btn = document.getElementById('clienteSelectBtn');
    const dropdown = document.getElementById('clienteDropdown');
    const searchInput = document.getElementById('clienteSearchInput');
    const listEl = document.getElementById('clienteList');
    const label = document.getElementById('clienteSelectLabel');
    const nombreHidden = document.getElementById('clienteNombre');
    const idHidden = document.getElementById('clienteId');
    const wrap = document.getElementById('clienteSelectWrap');
    if (!btn || !dropdown) return;

    const renderList = (query = '') => {
      const q = query.toLowerCase();
      const filtered = q.length < 1
        ? this.data.clientes.slice(0, 20)
        : this.data.clientes.filter(c =>
            (c.nombre_completo || '').toLowerCase().includes(q) ||
            (c.nombre_comercial || '').toLowerCase().includes(q) ||
            (c.codigo || '').toLowerCase().includes(q) ||
            (c.rfc || '').toLowerCase().includes(q)
          ).slice(0, 20);

      if (filtered.length === 0) {
        listEl.innerHTML = '<div style="padding:0.75rem;color:var(--text-muted);font-size:0.85rem;text-align:center;">No se encontraron clientes</div>';
      } else {
        listEl.innerHTML = filtered.map(c => `
          <div class="cliente-option" data-id="${c.id}" style="padding:0.6rem 0.75rem;cursor:pointer;border-bottom:1px solid var(--gray-50);transition:background 0.15s;">
            <div style="font-size:0.85rem;font-weight:600;color:#333;">${c.nombre_completo}</div>
            <div style="font-size:0.7rem;color:var(--text-muted);">${c.ciudad ? c.ciudad : ''}${c.rfc ? ' · ' + c.rfc : ''}</div>
          </div>
        `).join('');
      }

      listEl.querySelectorAll('.cliente-option').forEach(opt => {
        opt.addEventListener('mouseenter', () => opt.style.background = 'var(--bg-secondary)');
        opt.addEventListener('mouseleave', () => opt.style.background = '#fff');
        opt.addEventListener('click', () => {
          const cliente = this.data.clientes.find(c => c.id == opt.dataset.id);
          if (cliente) {
            label.textContent = cliente.nombre_completo;
            label.style.color = '#333';
            nombreHidden.value = cliente.nombre_completo;
            idHidden.value = cliente.id;
            // Llenar dirección
            if (cliente.direccion) {
              const direccionInput = document.querySelector('[name="direccion"]');
              if (direccionInput) direccionInput.value = cliente.direccion;
            }
          }
          dropdown.style.display = 'none';
          searchInput.value = '';
        });
      });
    };

    // Abrir/cerrar dropdown
    btn.addEventListener('click', () => {
      const isOpen = dropdown.style.display === 'block';
      dropdown.style.display = isOpen ? 'none' : 'block';
      if (!isOpen) {
        renderList();
        setTimeout(() => searchInput.focus(), 50);
      }
    });

    // Filtrar al escribir
    searchInput.addEventListener('input', () => renderList(searchInput.value.trim()));

    // Cerrar al hacer click fuera
    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) {
        dropdown.style.display = 'none';
        searchInput.value = '';
      }
    });
  },

  _toggleGarantiaEdit() {
    const checkbox = document.getElementById('garantiaCheckEdit');
    const toggle = document.getElementById('garantiaToggleEdit');
    const knob = document.getElementById('garantiaKnobEdit');
    if (!checkbox || checkbox.disabled) return;
    checkbox.checked = !checkbox.checked;
    toggle.style.background = checkbox.checked ? 'var(--primary)' : '#ccc';
    knob.style.left = checkbox.checked ? '22px' : '2px';
    this._showUnsaved();
  },

  _toggleGarantiaCreate() {
    const checkbox = document.getElementById('garantiaCheckCreate');
    const toggle = document.getElementById('garantiaToggleCreate');
    const knob = document.getElementById('garantiaToggleKnob');
    if (!checkbox || checkbox.disabled) return;
    checkbox.checked = !checkbox.checked;
    toggle.style.background = checkbox.checked ? 'var(--primary)' : '#ccc';
    knob.style.left = checkbox.checked ? '22px' : '2px';
  },

  _actualizarGarantiaCreacion() {
    const checkbox = document.getElementById('garantiaCheckCreate');
    const label = document.getElementById('garantiaLabel');
    const mensaje = document.getElementById('garantiaMensaje');
    const toggle = document.getElementById('garantiaToggleCreate');
    const knob = document.getElementById('garantiaToggleKnob');
    if (!checkbox || !label || !mensaje) return;

    const form = document.getElementById('formOrden');
    const horasMotor = parseFloat(form?.querySelector('[name="horas_motor"]')?.value || 0);
    const noAplica = horasMotor >= 1800;

    checkbox.disabled = noAplica;
    if (noAplica) {
      checkbox.checked = false;
      label.style.opacity = '0.5';
      label.style.cursor = 'not-allowed';
      if (toggle) toggle.style.background = '#ccc';
      if (knob) knob.style.left = '2px';
      mensaje.textContent = `El tractor tiene ${horasMotor} horas de motor, el límite es de 1,800 horas`;
      mensaje.style.display = 'block';
    } else {
      label.style.opacity = '1';
      label.style.cursor = 'pointer';
      mensaje.style.display = 'none';
    }
  },

  formatEstado(estado) {
    const estados = { 'abierta': 'Abierta', 'completada': 'Completada' };
    return estados[estado] || estado;
  },

  formatFecha(fecha) {
    if (!fecha) return '-';
    const parts = fecha.substring(0, 10).split('-');
    return parts.length === 3 ? `${parts[2]}/${parts[1]}/${parts[0]}` : '-';
  },

  /**
   * Intervalos distintos presentes en el checklist (varios bloques acumulados al crear la OT).
   */
  obtenerIntervalosListaDesdeOrden(o) {
    if (!o || o.tipo !== 'mantenimiento') return [50];
    const items = o.items_mantenimiento || [];
    const tiers = [...new Set(items.map((i) => i.intervalo_horas).filter((x) => x != null))].sort((a, b) => a - b);
    if (tiers.length) return tiers;
    return [this.calcularIntervalo(o.horas_motor)];
  },

  /**
   * Texto para encabezado: uno o varios intervalos separados por coma.
   */
  obtenerIntervaloEtiquetaDesdeOrden(o) {
    return this.obtenerIntervalosListaDesdeOrden(o).join(', ');
  },

  /**
   * Respaldo solo por horas; al crear la orden el backend usa OT completadas + horómetro.
   */
  calcularIntervalo(horasMotor) {
    const intervalos = [50, 350, 650, 950, 1250, 1550, 1850];
    for (let i = intervalos.length - 1; i >= 0; i--) {
      if (horasMotor >= intervalos[i]) {
        return intervalos[i];
      }
    }
    return 50;
  },

  /**
   * Enlaza horas/tipo para previsualizar intervalos (misma API que al crear la OT).
   */
  _setupIntervaloPreviewNueva() {
    const fp = document.getElementById('formularioPrincipal');
    const form = document.getElementById('formOrden');
    if (!fp || !form || fp.dataset.intervalBound === '1') return;
    fp.dataset.intervalBound = '1';
    const horasInput = form.querySelector('[name="horas_motor"]');
    const tipoSelect = form.querySelector('[name="tipo"]');
    const onChange = () => {
      this._refreshIntervaloPreviewNueva();
      this._actualizarGarantiaCreacion();
    };
    horasInput.addEventListener('input', onChange);
    horasInput.addEventListener('change', onChange);
    tipoSelect.addEventListener('change', onChange);
    onChange();
  },

  async _refreshIntervaloPreviewNueva() {
    const wrap = document.getElementById('intervaloPreviewWrap');
    const input = document.getElementById('intervaloPreviewInput');
    if (!wrap || !input) return;
    const form = document.getElementById('formOrden');
    const tipo = form?.querySelector('[name="tipo"]')?.value;
    const horasVal = parseFloat(form?.querySelector('[name="horas_motor"]')?.value);
    const numSerie = this.data.tractor?.num_serie;
    if (tipo !== 'mantenimiento' || !numSerie || Number.isNaN(horasVal)) {
      wrap.style.display = 'none';
      return;
    }
    wrap.style.display = 'block';
    input.value = '...';
    try {
      const res = await produccionService.calcularIntervaloMantenimientoOT(horasVal, numSerie);
      const payload = res.data != null ? res.data : res;
      // Un solo valor: el API envia `intervalo` (el aplicable); no usar join de `intervalos` por listas viejas
      const unico =
        payload.intervalo != null
          ? payload.intervalo
          : (Array.isArray(payload.intervalos) && payload.intervalos.length
              ? payload.intervalos[0]
              : this.calcularIntervalo(horasVal));
      input.value = `${unico} HR`;
    } catch (e) {
      input.value = `${this.calcularIntervalo(horasVal)} HR`;
    }
  },

  async buscarTractor(numSerie) {
    if (!numSerie) return;
    const infoEl = document.getElementById('tractorInfo');
    infoEl.textContent = 'Buscando tractor...';

    try {
      const response = await tractorService.getByNumSerie(numSerie);
      const tractor = response.data || response;
      if (tractor) {
        this.data.tractor = tractor;
        infoEl.innerHTML = `<span style="color: var(--success);">Encontrado: ${tractor.modelo} (${tractor.marca})</span>`;
      }
    } catch (error) {
      infoEl.innerHTML = `<span style="color: var(--danger);">Tractor no encontrado</span>`;
      this.data.tractor = null;
    }
  },

  async guardarNueva(e) {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    const distribuidorValue = formData.get('distribuidor_id');
    const tecnicoValue = formData.get('tecnico_servicio_id');
    const responsableValue = formData.get('responsable_posventa_id');

    // Obtener nombres de los selects
    const tecnicoSelect = form.querySelector('[name="tecnico_servicio_id"]');
    const responsableSelect = form.querySelector('[name="responsable_posventa_id"]');
    const tecnicoNombre = tecnicoSelect && tecnicoSelect.selectedIndex > 0 ? tecnicoSelect.options[tecnicoSelect.selectedIndex].text : null;
    const responsableNombre = responsableSelect && responsableSelect.selectedIndex > 0 ? responsableSelect.options[responsableSelect.selectedIndex].text : null;

    // Validar que se seleccionó un cliente
    const clienteNombre = document.getElementById('clienteNombre')?.value;
    const clienteId = document.getElementById('clienteId')?.value;
    if (!clienteNombre || !clienteId) {
      toast.error('Debe seleccionar un cliente de la lista');
      return;
    }

    const data = {
      num_serie: this.data.tractor?.num_serie || document.getElementById('numSerie').value.trim(),
      fecha: formData.get('fecha'),
      tipo: formData.get('tipo'),
      horas_motor: parseFloat(formData.get('horas_motor')),
      nombre_usuario: clienteNombre,
      persona_id: clienteId ? parseInt(clienteId, 10) : null,
      direccion: formData.get('direccion') || null,
      distribuidor_id: distribuidorValue ? parseInt(distribuidorValue, 10) : null,
      tecnico_servicio: tecnicoNombre,
      tecnico_servicio_id: tecnicoValue ? parseInt(tecnicoValue, 10) : null,
      responsable_posventa: responsableNombre,
      responsable_posventa_id: responsableValue ? parseInt(responsableValue, 10) : null,
      reporte_crm: formData.get('reporte_crm') || null,
      garantia: formData.get('garantia') === 'true',
      observaciones_previas: formData.get('observaciones_previas') || null
    };

    try {
      this._showProgress('Creando orden de trabajo...');
      const response = await produccionService.crearOrdenTrabajo(data);
      this._hideProgress();
      toast.success('Orden de trabajo creada');
      const orden = response.data || response;
      router.navigate(`/produccion/ordenes-trabajo/${orden.id}`);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al crear orden');
      console.error(error);
    }
  },

  toggleItemRow(id) {
    const detailRow = document.getElementById(`detail-item-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  toggleItemRealizado(itemId, realizado) {
    if (!this._editData) return;
    const item = this._editData.items_mantenimiento.find(i => i.id === itemId);
    if (item) item.realizado = realizado;
    this._showUnsaved();
  },

  agregarItemMantenimiento() {
    const intervalo = this.obtenerIntervalosListaDesdeOrden(this.data.orden)[0];
    modal.form(
      'Agregar Item de Mantenimiento',
      `
        <div class="form-group">
          <label class="form-label">Número de Item *</label>
          <input type="number" id="itemNumero" class="form-input" required />
        </div>
        <div class="form-group">
          <label class="form-label">Descripción *</label>
          <input type="text" id="itemDescripcion" class="form-input" required />
        </div>
        <div class="form-group">
          <label class="form-label">Acción *</label>
          <select id="itemAccion" class="form-select" required>
            <option value="Reemplazar">Reemplazar</option>
            <option value="Limpiar">Limpiar</option>
            <option value="Inspeccionar">Inspeccionar</option>
            <option value="Apretar">Apretar</option>
            <option value="Engrasar">Engrasar</option>
            <option value="Ajustar">Ajustar</option>
            <option value="Verificar/Ajustar">Verificar/Ajustar</option>
            <option value="Inspeccionar/Ajustar">Inspeccionar/Ajustar</option>
            <option value="Drenar/Inspeccionar">Drenar/Inspeccionar</option>
            <option value="Mantenimiento">Mantenimiento</option>
          </select>
        </div>
        <p style="color: var(--text-muted); font-size: 0.875rem;">Intervalo: ${intervalo} HR (mismo checklist que la orden)</p>
      `,
      () => {
        if (!this._editData) return;

        const maxId = this._editData.items_mantenimiento.reduce((max, i) => Math.max(max, i.id || 0), 0);
        this._editData.items_mantenimiento.push({
          id: maxId + 1,
          item_numero: parseInt(document.getElementById('itemNumero').value),
          descripcion: document.getElementById('itemDescripcion').value,
          accion: document.getElementById('itemAccion').value,
          intervalo_horas: intervalo,
          estado_visual: null,
          realizado: false
        });

        // Re-render tab
        const content = document.getElementById('tabContent');
        if (content) content.innerHTML = this.renderTabMantenimiento();
        this._showUnsaved();
        modal.close();
      }
    );
  },

  agregarDiagnostico() {
    const overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:center;justify-content:center;';
    overlay.innerHTML = `
      <div style="background:#fff;border-radius:16px;width:95%;max-width:500px;box-shadow:0 16px 48px rgba(0,0,0,0.35);overflow:hidden;max-height:90vh;overflow-y:auto;">
        <!-- Header -->
        <div style="background:var(--primary);padding:1rem 1.25rem;display:flex;justify-content:space-between;align-items:flex-start;">
          <div>
            <h3 style="margin:0 0 0.15rem;font-size:1rem;font-weight:700;color:#fff;">Agregar diagnóstico</h3>
            <p style="margin:0;font-size:0.75rem;color:rgba(255,255,255,0.7);">Diagnósticos y soluciones</p>
          </div>
          <button type="button" id="diagCerrar" style="background:none;border:none;color:rgba(255,255,255,0.6);font-size:1.4rem;cursor:pointer;padding:0;line-height:1;">&times;</button>
        </div>
        <!-- Contenido -->
        <div style="padding:1.25rem;">
          <!-- Problema -->
          <div style="margin-bottom:1rem;">
            <h4 style="font-size:0.75rem;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;color:var(--gray-700);margin:0 0 0.75rem;padding-bottom:0.5rem;border-bottom:1px solid var(--gray-200);">Problema</h4>
            <div style="margin-bottom:0.75rem;">
              <label style="font-size:0.7rem;color:var(--gray-500);margin-bottom:0.25rem;display:block;">Diagnóstico</label>
              <textarea id="diagDiagnostico" class="form-input" rows="3" placeholder="Describe el problema encontrado..."></textarea>
            </div>
            <div>
              <label style="font-size:0.7rem;color:var(--gray-500);margin-bottom:0.25rem;display:block;">Solución</label>
              <textarea id="diagSolucion" class="form-input" rows="3" placeholder="Solución aplicada o recomendada..."></textarea>
            </div>
          </div>
          <!-- Refacción -->
          <div style="margin-bottom:1rem;">
            <h4 style="font-size:0.75rem;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;color:var(--gray-700);margin:0 0 0.75rem;padding-bottom:0.5rem;border-bottom:1px solid var(--gray-200);">Refacción</h4>
            <div style="display:grid;grid-template-columns:2fr 1fr;gap:0.5rem;margin-bottom:0.75rem;">
              <div>
                <label style="font-size:0.7rem;color:var(--gray-500);margin-bottom:0.25rem;display:block;">Código de parte</label>
                <input type="text" id="diagCodigoParte" class="form-input" placeholder="Ej. 4521-A" />
              </div>
              <div>
                <label style="font-size:0.7rem;color:var(--gray-500);margin-bottom:0.25rem;display:block;">Cantidad</label>
                <input type="number" id="diagCantidad" class="form-input" min="0" value="0" />
              </div>
            </div>
            <div>
              <label style="font-size:0.7rem;color:var(--gray-500);margin-bottom:0.25rem;display:block;">Acción</label>
              <select id="diagAccion" class="form-select">
                <option value="">-- Seleccionar --</option>
                <option value="Reemplazar">Reemplazar</option>
                <option value="Limpiar">Limpiar</option>
                <option value="Inspeccionar">Inspeccionar</option>
                <option value="Apretar">Apretar</option>
                <option value="Engrasar">Engrasar</option>
                <option value="Ajustar">Ajustar</option>
                <option value="Verificar/Ajustar">Verificar/Ajustar</option>
                <option value="Inspeccionar/Ajustar">Inspeccionar/Ajustar</option>
                <option value="Drenar/Inspeccionar">Drenar/Inspeccionar</option>
                <option value="Mantenimiento">Mantenimiento</option>
              </select>
            </div>
          </div>
        </div>
        <!-- Acciones -->
        <div style="padding:0 1.25rem 1.25rem;display:flex;gap:0.75rem;justify-content:flex-end;">
          <button type="button" id="diagCancelar" style="padding:0.6rem 1.5rem;border:1px solid #dee2e6;border-radius:10px;background:#fff;color:#333;font-size:0.85rem;font-weight:600;cursor:pointer;">Cancelar</button>
          <button type="button" id="diagGuardar" style="padding:0.6rem 1.5rem;border:none;border-radius:10px;background:var(--primary);color:#fff;font-size:0.85rem;font-weight:600;cursor:pointer;">Guardar diagnóstico</button>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);

    const cerrar = () => overlay.remove();
    document.getElementById('diagCerrar').addEventListener('click', cerrar);
    document.getElementById('diagCancelar').addEventListener('click', cerrar);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) cerrar(); });

    document.getElementById('diagGuardar').addEventListener('click', () => {
      if (!this._editData) return;

      const diagnostico = document.getElementById('diagDiagnostico').value.trim();
      const solucion = document.getElementById('diagSolucion').value.trim();
      const codigoParte = document.getElementById('diagCodigoParte').value.trim();
      const accion = document.getElementById('diagAccion').value;
      const cantidad = document.getElementById('diagCantidad').value;

      if (!diagnostico) { toast.error('El diagnóstico es obligatorio'); return; }
      if (!solucion) { toast.error('La solución es obligatoria'); return; }
      if (!codigoParte) { toast.error('El código de parte es obligatorio'); return; }
      if (!accion) { toast.error('La acción es obligatoria'); return; }
      if (!cantidad || parseInt(cantidad) <= 0) { toast.error('La cantidad es obligatoria'); return; }

      const maxId = this._editData.diagnosticos.reduce((max, d) => Math.max(max, d.id || 0), 0);
      this._editData.diagnosticos.push({
        id: maxId + 1,
        diagnostico: diagnostico,
        solucion: solucion,
        codigo_parte: codigoParte,
        accion: accion,
        cantidad: parseInt(cantidad)
      });

      const content = document.getElementById('tabContent');
      if (content) content.innerHTML = this.renderTabDiagnosticos();
      this._showUnsaved();
      cerrar();
    });
  },

  eliminarDiagnostico(id) {
    if (!this._editData) return;

    modal.confirm('Eliminar Diagnóstico', '¿Está seguro?', () => {
      const idx = this._editData.diagnosticos.findIndex(d => d.id === id);
      if (idx >= 0) {
        this._editData.diagnosticos.splice(idx, 1);
      }
      // Re-render tab
      const content = document.getElementById('tabContent');
      if (content) content.innerHTML = this.renderTabDiagnosticos();
      this._showUnsaved();
    });
  },

  async cambiarEstado(nuevoEstado) {
    const confirmMsg = '¿Está seguro de cambiar el estado?';

    modal.confirm('Cambiar Estado', confirmMsg, async () => {
      try {
        await produccionService.cambiarEstadoOrden(this.data.orden.id, nuevoEstado);
        toast.success('Estado actualizado');
        await this.cargarOrden(this.data.orden.id);
      } catch (error) {
        toast.error(error.message || 'Error al cambiar estado');
      }
    });
  },


  async descargarPDF() {
    const o = this.data.orden;
    if (!o) return;

    toast.info('Generando PDF...');

    try {
      // Cargar html2pdf.js desde CDN si no está cargado
      if (typeof html2pdf === 'undefined') {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.2/html2pdf.bundle.min.js';
          script.onload = resolve;
          script.onerror = () => reject(new Error('Error al cargar librería PDF'));
          document.head.appendChild(script);
        });
      }

      // Obtener plantilla completa
      const plantillaResponse = await produccionService.obtenerPlantillaCompleta().catch(() => ({ data: [] }));
      const plantilla = plantillaResponse.data || plantillaResponse || [];

      // Generar HTML
      const html = PrintOrdenTrabajo.generateHTML(o, plantilla);

      // Crear contenedor temporal
      const container = document.createElement('div');
      container.style.cssText = 'position:fixed; left:-9999px; top:0; width:216mm;';
      container.innerHTML = `<div class="ot-pdf-wrapper">${html}</div>`;
      document.body.appendChild(container);

      // Esperar a que las imágenes carguen
      const imgs = container.querySelectorAll('img');
      await Promise.all(Array.from(imgs).map(img =>
        img.complete ? Promise.resolve() : new Promise(r => { img.onload = r; img.onerror = r; })
      ));

      // Fix para html2canvas: reemplazar texto con writing-mode por canvas rotado (alta resolución)
      const dpr = 4; // factor de resolución para nitidez en PDF
      container.querySelectorAll('.mant-model-rotated, .mant-interval-rotated').forEach(el => {
        const text = el.textContent.trim();
        const isInterval = el.classList.contains('mant-interval-rotated');
        const fontSize = isInterval ? 10 : 6;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        ctx.font = `bold ${fontSize * dpr}px Arial`;
        const tw = ctx.measureText(text).width;
        const cw = Math.ceil((fontSize + 4) * dpr);
        const ch = Math.ceil(tw + 4 * dpr);
        canvas.width = cw;
        canvas.height = ch;
        ctx.font = `bold ${fontSize * dpr}px Arial`;
        ctx.fillStyle = '#000';
        ctx.translate(fontSize * dpr, tw + 2 * dpr);
        ctx.rotate(-Math.PI / 2);
        ctx.textBaseline = 'middle';
        ctx.fillText(text, 0, 0);
        el.innerHTML = '';
        el.style.writingMode = 'initial';
        el.style.transform = 'none';
        el.style.padding = '0';
        el.appendChild(canvas);
        canvas.style.display = 'block';
        canvas.style.margin = '0 auto';
        canvas.style.width = `${Math.ceil((fontSize + 4))}px`;
        canvas.style.height = `${Math.ceil(tw / dpr + 4)}px`;
      });

      // Fix para html2canvas: reducir tamaño de firmas
      container.querySelectorAll('img').forEach(img => {
        const src = img.getAttribute('src') || '';
        if (src.includes('firma')) {
          img.style.maxHeight = '28px';
          img.style.maxWidth = '56px';
        }
      });

      window.scrollTo(0, 0);
      await new Promise(r => setTimeout(r, 500));

      const target = container.querySelector('.ot-pdf-wrapper');

      await html2pdf().set({
        margin: 0,
        filename: `OT_${o.num_serie}.pdf`,
        image: { type: 'png' },
        html2canvas: { scale: 3, useCORS: true, scrollY: 0 },
        jsPDF: { unit: 'mm', format: [216, 340], orientation: 'portrait' },
        pagebreak: { mode: 'avoid-all', before: '.page-2' }
      }).from(target).save();

      document.body.removeChild(container);
      toast.success('PDF descargado');
    } catch (error) {
      toast.error('Error al generar PDF');
      console.error(error);
    }
  },

  async completarOrden() {
    // Primero guardar cambios pendientes (patrón Recepciones)
    if (this._hasUnsaved) {
      toast.warning('Guarde los cambios antes de completar la orden');
      return;
    }

    const o = this.data.orden;
    const data = this._editData || o;
    const niveles = data.niveles || [];
    const items = data.items_mantenimiento || [];

    // Validar reporte CRM
    const reporteCrmInput = document.querySelector('[name="reporte_crm_edit"]');
    const reporteCrm = reporteCrmInput ? reporteCrmInput.value.trim() : (o.reporte_crm || '');
    if (!reporteCrm) {
      toast.error('El Reporte CRM es obligatorio');
      return;
    }

    // Validar niveles previos (solo los que aplican al modelo; ver `modelos.niveles_no_aplican`).
    // Se verifica fluido por fluido en vez de contar: contar dejaba pasar el caso de un
    // fluido aplicable faltante compensado por un valor viejo de uno que ya no aplica.
    const fluidosAplicables = this._fluidosAplicables();
    const previos = niveles.filter(n => n.momento === 'previo');
    if (fluidosAplicables.some(f => !previos.some(n => n.tipo_fluido === f.key))) {
      this.showTab('niveles-previos');
      toast.error('Complete todos los niveles previos');
      return;
    }

    // Validar items mantenimiento (solo si aplica el modelo)
    const checklistAplica = this._isModeloAplica() || items.length > 0;
    if (checklistAplica && (items.length === 0 || items.some(i => !i.realizado))) {
      this.showTab('mantenimiento');
      toast.error('Complete todos los items de mantenimiento');
      return;
    }

    // Validar niveles posteriores (solo los que aplican al modelo)
    const posteriores = niveles.filter(n => n.momento === 'posterior');
    if (fluidosAplicables.some(f => !posteriores.some(n => n.tipo_fluido === f.key))) {
      this.showTab('niveles-posteriores');
      toast.error('Complete todos los niveles posteriores');
      return;
    }

    // Validar firmas (persistidas — ya se guardaron con "Guardar cambios")
    if (!o.tecnico_servicio_firma_url) {
      this.showTab('firmas');
      toast.error('Falta firma del Técnico de Servicio');
      return;
    }
    if (!o.usuario_firma_url) {
      this.showTab('firmas');
      toast.error('Falta firma del Usuario');
      return;
    }
    if (!o.responsable_posventa_firma_url) {
      this.showTab('firmas');
      toast.error('Falta firma del Responsable Posventa');
      return;
    }

    // Confirmar antes de completar
    modal.confirm('Completar Orden de Trabajo', '¿Está seguro de completar esta orden? No podrá editarla después.', async () => {
      try {
        const completarData = {
          tecnico_servicio: o.tecnico_servicio || null,
          tecnico_servicio_id: o.tecnico_servicio_id || null,
          tecnico_servicio_firma_url: o.tecnico_servicio_firma_url || null,
          usuario_firma_url: o.usuario_firma_url || null,
          responsable_posventa: o.responsable_posventa || null,
          responsable_posventa_id: o.responsable_posventa_id || null,
          responsable_posventa_firma_url: o.responsable_posventa_firma_url || null,
          observaciones_posteriores: document.getElementById('observacionesFinales')?.value || null
        };

        this._showProgress('Completando orden...');
        await produccionService.completarOrdenTrabajo(this.data.orden.id, completarData);
        this._hideProgress();
        toast.success('Orden completada');
        await this.cargarOrden(this.data.orden.id);
      } catch (error) {
        this._hideProgress();
        toast.error(error.message || 'Error al completar');
      }
    });
  },

  initFirmasCompletar() {
    const canvasTecnico = document.getElementById('firma-tecnico');
    const canvasUsuario = document.getElementById('firma-usuario');
    const canvasResponsable = document.getElementById('firma-responsable');

    // Salir solo si ningún canvas está disponible (nada que inicializar)
    if (!canvasTecnico && !canvasUsuario && !canvasResponsable) return;

    const resizeCanvas = (canvas) => {
      const rect = canvas.getBoundingClientRect();
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = rect.width * ratio;
      canvas.height = rect.height * ratio;
      canvas.getContext('2d').scale(ratio, ratio);
    };

    const initPad = (canvas) => {
      resizeCanvas(canvas);
      const pad = new SignaturePad(canvas, {
        backgroundColor: 'rgb(255, 255, 255)',
        penColor: 'rgb(0, 0, 0)'
      });

      const hidePlaceholder = () => {
        const placeholder = document.getElementById(`firma-placeholder-${canvas.id.replace('firma-', '')}`);
        if (placeholder) placeholder.style.display = 'none';
      };
      canvas.addEventListener('pointerdown', hidePlaceholder);
      canvas.addEventListener('touchstart', hidePlaceholder);

      // Activar indicador "hay cambios" al terminar un trazo
      pad.addEventListener('endStroke', () => this._showUnsaved());

      return pad;
    };

    this.signaturePadTecnico = canvasTecnico ? initPad(canvasTecnico) : null;
    this.signaturePadUsuario = canvasUsuario ? initPad(canvasUsuario) : null;
    this.signaturePadResponsable = canvasResponsable ? initPad(canvasResponsable) : null;
  },

  limpiarFirmaCompletar(tipo) {
    const padMap = {
      tecnico: this.signaturePadTecnico,
      usuario: this.signaturePadUsuario,
      responsable: this.signaturePadResponsable
    };

    const pad = padMap[tipo];
    if (pad) {
      const tenia = !pad.isEmpty();
      pad.clear();
      const placeholder = document.getElementById(`firma-placeholder-${tipo}`);
      if (placeholder) placeholder.style.display = '';
      if (tenia) this._showUnsaved();
    }
  },

  async toBlob(signaturePad) {
    const dataURL = signaturePad.toDataURL('image/png');
    const response = await fetch(dataURL);
    return response.blob();
  }
};
